'use strict';

/*
  Secret Gifters Portaal JavaScript
  Versie: 2.2.0 (Kalender herbouw - 29 april 2026)
  Laatste update: Kalender herbouwd met expliciete grid-column-start;
                  alignering kan wiskundig niet meer verschuiven.
*/

/* ── Configuratie ────────────────────────────────────────── */
// Geheime waarden worden nooit hier opgeslagen — alleen via Shopify theme
// settings (Online Store → Themes → Customize → Theme settings) of via
// data-attributen op <body>. Lege defaults voorkomen dat tokens in git komen.
const PORTAAL_CONFIG = {
  airtableBaseId: '',
  airtableApiKey: '',

  makeWebhooks: {
    // Geen webhook-URL's hier hardcoden: dit bestand is een publiek theme-
    // asset en iedereen kan zulke URL's direct aanroepen. Alle webhooks
    // lopen via de beveiligde proxy (portaal-config.liquid → proxy:*).
    medewerkerToevoegen: '',
    csvImport: '',
    momentToevoegen: '',
    planningGenereren: '',
    bedrijfsinfoOpslaan: '',
    accountOpzeggen: '',
    gebruikerUitnodigen: '',
    crmSync: '',             // Webhook voor CRM medewerker-synchronisatie
    emailWijzigen: ''        // Webhook voor e-mailadres wijziging
  }
};

// Sync vanuit window.PORTAAL_CONFIG (gezet door portaal-config.liquid snippet),
// zodat useProxy/apiBase/proxy-webhooks ook in portaal.js bekend zijn en de
// CRM/Exact/Sync flows niet vroegtijdig naar legacy-mode terugvallen.
if (typeof window !== 'undefined' && window.PORTAAL_CONFIG) {
  if (window.PORTAAL_CONFIG.makeWebhooks) {
    Object.assign(PORTAAL_CONFIG.makeWebhooks, window.PORTAAL_CONFIG.makeWebhooks);
  }
  for (const k of Object.keys(window.PORTAAL_CONFIG)) {
    if (k !== 'makeWebhooks') PORTAAL_CONFIG[k] = window.PORTAAL_CONFIG[k];
  }
}
window.PORTAAL_CONFIG = PORTAAL_CONFIG;

/* ── Init ─────────────────────────────────────────────────── */
function initPortaal() {
  const body = document.body;

  // Laad configuratie vanuit Shopify theme settings
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings) {
    const settings = window.Shopify.theme.settings;

    if (settings.airtable_base_id) PORTAAL_CONFIG.airtableBaseId = settings.airtable_base_id;
    if (settings.airtable_api_token) PORTAAL_CONFIG.airtableApiKey = settings.airtable_api_token;

    if (settings.webhook_medewerker) PORTAAL_CONFIG.makeWebhooks.medewerkerToevoegen = settings.webhook_medewerker;
    if (settings.webhook_csv) PORTAAL_CONFIG.makeWebhooks.csvImport = settings.webhook_csv;
    if (settings.webhook_moment) PORTAAL_CONFIG.makeWebhooks.momentToevoegen = settings.webhook_moment;
    if (settings.webhook_planning) PORTAAL_CONFIG.makeWebhooks.planningGenereren = settings.webhook_planning;
    if (settings.webhook_bedrijfsinfo) PORTAAL_CONFIG.makeWebhooks.bedrijfsinfoOpslaan = settings.webhook_bedrijfsinfo;
    if (settings.webhook_account_opzeggen) PORTAAL_CONFIG.makeWebhooks.accountOpzeggen = settings.webhook_account_opzeggen;
    if (settings.webhook_gebruiker_uitnodigen) PORTAAL_CONFIG.makeWebhooks.gebruikerUitnodigen = settings.webhook_gebruiker_uitnodigen;
    if (settings.webhook_crm_sync) PORTAAL_CONFIG.makeWebhooks.crmSync = settings.webhook_crm_sync;
    if (settings.webhook_email_wijzigen) PORTAAL_CONFIG.makeWebhooks.emailWijzigen = settings.webhook_email_wijzigen;
  }

  // Fallback: Laad configuratie vanuit body data-attributen
  if (body.dataset.airtableBase) PORTAAL_CONFIG.airtableBaseId = body.dataset.airtableBase;
  if (body.dataset.airtableKey) PORTAAL_CONFIG.airtableApiKey = body.dataset.airtableKey;
  if (body.dataset.webhookMedewerker) PORTAAL_CONFIG.makeWebhooks.medewerkerToevoegen = body.dataset.webhookMedewerker;
  if (body.dataset.webhookCsv) PORTAAL_CONFIG.makeWebhooks.csvImport = body.dataset.webhookCsv;
  if (body.dataset.webhookMoment) PORTAAL_CONFIG.makeWebhooks.momentToevoegen = body.dataset.webhookMoment;
  if (body.dataset.webhookPlanning) PORTAAL_CONFIG.makeWebhooks.planningGenereren = body.dataset.webhookPlanning;
  if (body.dataset.webhookBedrijfsinfo) PORTAAL_CONFIG.makeWebhooks.bedrijfsinfoOpslaan = body.dataset.webhookBedrijfsinfo;
  if (body.dataset.webhookAccountOpzeggen) PORTAAL_CONFIG.makeWebhooks.accountOpzeggen = body.dataset.webhookAccountOpzeggen;
  if (body.dataset.webhookCrmSync) PORTAAL_CONFIG.makeWebhooks.crmSync = body.dataset.webhookCrmSync;
  if (body.dataset.webhookGebruikerUitnodigen) PORTAAL_CONFIG.makeWebhooks.gebruikerUitnodigen = body.dataset.webhookGebruikerUitnodigen;
  if (body.dataset.webhookEmailWijzigen) PORTAAL_CONFIG.makeWebhooks.emailWijzigen = body.dataset.webhookEmailWijzigen;

  // Voeg portaal-pagina class toe aan body
  if (
    document.querySelector('.portaal-wrapper') ||
    document.querySelector('.portaal-login-pagina')
  ) {
    body.classList.add('portaal-pagina');
  }

  // ── Sub-gebruiker email resolutie ───────────────────────────
  // Als dit een sub-gebruiker is, update alle data-klant-email attributen
  // zodat ze de data van het hoofd-account zien.
  (async () => {
    const eigenEmailEls = document.querySelectorAll('[data-klant-email]');
    if (eigenEmailEls.length === 0) return;

    const eigenEmail = eigenEmailEls[0].dataset.klantEmail;
    if (!eigenEmail) return;

    const hoofdEmail = await resolveerEffectiefEmail(eigenEmail);
    if (hoofdEmail && hoofdEmail !== eigenEmail) {
      // Dit is een sub-gebruiker — update alle elementen met het hoofd-email
      window._isSubGebruiker = true;
      window._hoofdEmail = hoofdEmail;
      eigenEmailEls.forEach(el => {
        el.dataset.klantEmail = hoofdEmail;
        el.dataset.eigenEmail = eigenEmail;
      });

      // Toon sub-gebruiker banner
      toonSubGebruikerBanner(eigenEmail, hoofdEmail);
    }
  })();

  initNav();
}

/* ── Navigatie ────────────────────────────────────────────── */
function initNav() {
  const hamburger = document.getElementById('portaal-hamburger');
  const mobielMenu = document.getElementById('portaal-mobiel-menu');
  if (!hamburger || !mobielMenu) return;

  hamburger.addEventListener('click', () => {
    mobielMenu.classList.toggle('open');
    hamburger.setAttribute('aria-expanded', mobielMenu.classList.contains('open'));
  });

  document.addEventListener('click', (e) => {
    if (!hamburger.contains(e.target) && !mobielMenu.contains(e.target)) {
      mobielMenu.classList.remove('open');
    }
  });
}

/* ── Airtable API ─────────────────────────────────────────── */
async function fetchAirtable(table, filterFormula = null, sortField = null, sortDir = 'asc') {
  // Airtable levert max 100 records per pagina; loop door alle pagina's
  // zodat de aanroeper niet stilzwijgend de eerste 100 alfabetisch krijgt.
  // Bij een fout midden in de loop geven we WAT WE HEBBEN terug i.p.v. [];
  // anders verliest de UI per ongeluk alle records bij een rate-limit op pagina 2.
  const baseUrl = `https://api.airtable.com/v0/${PORTAAL_CONFIG.airtableBaseId}/${encodeURIComponent(table)}`;
  const all = [];
  let offset = null;
  const MAX_PAGES = 50; // veiligheidsslot tegen oneindige lus
  let pageCount = 0;

  while (pageCount < MAX_PAGES) {
    pageCount += 1;
    try {
      const params = new URLSearchParams();
      if (filterFormula) params.set('filterByFormula', filterFormula);
      if (sortField) {
        params.set('sort[0][field]', sortField);
        params.set('sort[0][direction]', sortDir);
      }
      if (offset) params.set('offset', offset);

      const url = `${baseUrl}?${params}`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${PORTAAL_CONFIG.airtableApiKey}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        console.error(`fetchAirtable ${table} pagina ${pageCount} status ${response.status} — partial: ${all.length}`);
        break;
      }
      const data = await response.json();
      if (Array.isArray(data.records)) all.push(...data.records);
      if (!data.offset) break;
      offset = data.offset;
    } catch (err) {
      console.error(`fetchAirtable ${table} pagina ${pageCount} fout:`, err, `partial: ${all.length}`);
      break;
    }
  }
  return all;
}

async function createAirtableRecord(table, fields) {
  const url = `https://api.airtable.com/v0/${PORTAAL_CONFIG.airtableBaseId}/${encodeURIComponent(table)}`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${PORTAAL_CONFIG.airtableApiKey}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ fields })
    });

    if (!response.ok) throw new Error(`Airtable aanmaken fout: ${response.status}`);
    return await response.json();
  } catch (err) {
    console.error('createAirtableRecord fout:', err);
    throw err;
  }
}

async function updateAirtableRecord(table, recordId, fields) {
  const url = `https://api.airtable.com/v0/${PORTAAL_CONFIG.airtableBaseId}/${encodeURIComponent(table)}/${recordId}`;

  try {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${PORTAAL_CONFIG.airtableApiKey}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ fields })
    });

    if (!response.ok) throw new Error(`Airtable update fout: ${response.status}`);
    return await response.json();
  } catch (err) {
    console.error('updateAirtableRecord fout:', err);
    throw err;
  }
}

async function deleteAirtableRecord(table, recordId) {
  const url = `https://api.airtable.com/v0/${PORTAAL_CONFIG.airtableBaseId}/${encodeURIComponent(table)}/${recordId}`;

  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${PORTAAL_CONFIG.airtableApiKey}` }
    });

    if (!response.ok) throw new Error(`Airtable verwijderen fout: ${response.status}`);
    return true;
  } catch (err) {
    console.error('deleteAirtableRecord fout:', err);
    return false;
  }
}

/* ── Make Webhook ─────────────────────────────────────────── */
async function postWebhook(url, data) {
  if (!url || url.includes('JOUW_WEBHOOK')) {
    console.warn('Webhook URL niet geconfigureerd. Stel de URL in via Make.com en voeg hem toe aan PORTAAL_CONFIG.');
    throw new Error('Webhook niet geconfigureerd');
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    if (!response.ok) throw new Error(`Webhook fout: ${response.status}`);
    return response;
  } catch (err) {
    console.error('postWebhook fout:', err);
    throw err;
  }
}

/* ── Modal ────────────────────────────────────────────────── */
function openModal(overlayId) {
  const overlay = document.getElementById(overlayId);
  if (!overlay) return;
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';

  const clickHandler = (e) => {
    if (e.target === overlay) {
      closeModal(overlayId);
      overlay.removeEventListener('click', clickHandler);
    }
  };
  overlay.addEventListener('click', clickHandler);

  const escHandler = (e) => {
    if (e.key === 'Escape') {
      closeModal(overlayId);
      document.removeEventListener('keydown', escHandler);
    }
  };
  document.addEventListener('keydown', escHandler);
}

function closeModal(overlayId) {
  const overlay = document.getElementById(overlayId);
  if (!overlay) return;
  overlay.classList.remove('open');
  document.body.style.overflow = '';
}

/* ── Bevestig (vervangt confirm) ──────────────────────────────
   Toont een portaal-modal met "Annuleren" / "Bevestigen" knoppen.
   Returnt een Promise die naar true (bevestigd) of false (geannuleerd) resolved.
   Gebruik:
     if (await bevestig({ titel: 'Verwijderen?', tekst: '...', destructief: true })) { ... }
─────────────────────────────────────────────────────────────── */
function bevestig({ titel, tekst, bevestigTekst = 'Ja, doorgaan', annulerenTekst = 'Annuleren', destructief = false } = {}) {
  return new Promise(resolve => {
    const id = 'portaal-bevestig-' + Date.now();
    const bevestigKlasse = destructief ? 'portaal-knop-danger' : 'portaal-knop-navy';

    const html = `
      <div class="portaal-modal-overlay open" id="${id}">
        <div class="portaal-modal" style="max-width:460px;text-align:center;padding:32px 28px;">
          ${destructief ? `
            <div class="opzegging-modal-icoon" style="margin:0 auto 16px;">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M14 3L25.66 23H2.34L14 3Z" stroke="#B91C1C" stroke-width="1.8" stroke-linejoin="round" fill="none"/>
                <path d="M14 11V16.5" stroke="#B91C1C" stroke-width="1.8" stroke-linecap="round"/>
                <circle cx="14" cy="19.5" r="1" fill="#B91C1C"/>
              </svg>
            </div>` : ''}
          <h2 style="font-size:1.6rem;font-weight:800;color:var(--portaal-navy);margin:0 0 10px;">${escHtml(titel || 'Bevestigen')}</h2>
          <p style="font-size:1.25rem;color:var(--portaal-tekst-muted);line-height:1.55;margin:0 0 24px;">${escHtml(tekst || '')}</p>
          <div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;">
            <button class="portaal-knop-secondary" data-bevestig-actie="annuleren">${escHtml(annulerenTekst)}</button>
            <button class="${bevestigKlasse}" data-bevestig-actie="bevestigen">${escHtml(bevestigTekst)}</button>
          </div>
        </div>
      </div>`;

    document.body.insertAdjacentHTML('beforeend', html);
    document.body.style.overflow = 'hidden';

    const overlay = document.getElementById(id);

    const sluit = (resultaat) => {
      overlay.remove();
      document.body.style.overflow = '';
      resolve(resultaat);
    };

    overlay.querySelector('[data-bevestig-actie="bevestigen"]').addEventListener('click', () => sluit(true));
    overlay.querySelector('[data-bevestig-actie="annuleren"]').addEventListener('click', () => sluit(false));
    overlay.addEventListener('click', e => { if (e.target === overlay) sluit(false); });

    const escHandler = e => {
      if (e.key === 'Escape') {
        document.removeEventListener('keydown', escHandler);
        sluit(false);
      }
    };
    document.addEventListener('keydown', escHandler);
  });
}

/* ── Tabs ─────────────────────────────────────────────────── */
function initTabs(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const tabs = container.querySelectorAll('.portaal-tab');
  const inhouden = container.querySelectorAll('.portaal-tab-inhoud');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => { t.classList.remove('actief'); t.setAttribute('aria-selected', 'false'); });
      inhouden.forEach(i => i.classList.remove('actief'));
      tab.classList.add('actief');
      tab.setAttribute('aria-selected', 'true');
      if (inhouden[index]) inhouden[index].classList.add('actief');
    });
  });
}

/* ── Kalender ─────────────────────────────────────────────────
   Bulletproof aanpak: i.p.v. lege cellen toevoegen vóór dag 1,
   zetten we dag 1 expliciet op de juiste CSS-grid kolom met
   `grid-column-start`. De rest van de dagen stroomt automatisch.
   Onze headers zijn Ma/Di/Wo/Do/Vr/Za/Zo (kolom 1 t/m 7).
   JS Date.getDay() geeft: 0=Zo, 1=Ma, 2=Di, 3=Wo, 4=Do, 5=Vr, 6=Za.
   Dus mapping naar onze kolom-index (1-based, Ma=1):
     Zo (0) → 7,  Ma (1) → 1,  Di (2) → 2,  Wo (3) → 3,
     Do (4) → 4,  Vr (5) → 5,  Za (6) → 6.
─────────────────────────────────────────────────────────────── */
function initKalender(containerId, momentenData) {
  const container = document.getElementById(containerId);
  if (!container) return;

  container._momenten = momentenData || [];

  // Initiele maand: pas zetten bij eerste call, daarna behouden
  // zodat een reload van momenten de gebruiker niet terug naar
  // de huidige maand schopt na navigatie.
  if (typeof container._jaar === 'undefined') {
    const nu = new Date();
    container._jaar  = nu.getFullYear();
    container._maand = nu.getMonth();
  }

  const maandNamen = [
    'januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december'
  ];

  function lokaalDatumStr(jaar, maand, dag) {
    return `${jaar}-${String(maand + 1).padStart(2, '0')}-${String(dag).padStart(2, '0')}`;
  }

  function jsDayNaarKolom(jsDay) {
    // 0=Zo → 7, anders 1:1 (Ma=1 .. Za=6)
    return jsDay === 0 ? 7 : jsDay;
  }

  function renderKalender(jaar, maand) {
    const eerstedag   = new Date(jaar, maand, 1);
    const aantalDagen = new Date(jaar, maand + 1, 0).getDate();
    const startKolom  = jsDayNaarKolom(eerstedag.getDay());

    const maandEl = container.querySelector('.portaal-kalender__maand');
    if (maandEl) maandEl.textContent = `${maandNamen[maand]} ${jaar}`;

    const dagenGrid = container.querySelector('.portaal-kalender__dagen');
    if (!dagenGrid) return;
    dagenGrid.innerHTML = '';

    const vandaag    = new Date();
    const vandaagStr = lokaalDatumStr(vandaag.getFullYear(), vandaag.getMonth(), vandaag.getDate());
    const data       = container._momenten || [];

    for (let dag = 1; dag <= aantalDagen; dag++) {
      const datumStr = lokaalDatumStr(jaar, maand, dag);
      const dagEl = document.createElement('div');
      dagEl.className = 'portaal-kalender__dag';

      // Dag 1 krijgt de expliciete startkolom — alle andere dagen
      // stromen daarna automatisch via CSS grid auto-placement.
      if (dag === 1) {
        dagEl.style.gridColumnStart = String(startKolom);
      }

      if (datumStr === vandaagStr) {
        dagEl.classList.add('portaal-kalender__dag--vandaag');
      }

      const momentenOpDag = data.filter(m => {
        const mDatum = m.fields && m.fields['Datum'] ? m.fields['Datum'].split('T')[0] : '';
        return mDatum === datumStr;
      });

      const dagNummer = document.createElement('span');
      dagNummer.textContent = dag;
      dagEl.appendChild(dagNummer);

      if (momentenOpDag.length > 0) {
        dagEl.classList.add('portaal-kalender__dag--heeft-momenten');

        // Per moment één gekleurd stipje, gegroepeerd onderaan de cel.
        // Type bepaalt de kleur (zie CSS). Boven 3 momenten knippen we
        // af met "+N" om de cel niet te overladen.
        const stippenRij = document.createElement('div');
        stippenRij.className = 'portaal-kalender__dag-stippen';
        const maxStippen = 3;
        const tonen = momentenOpDag.slice(0, maxStippen);
        tonen.forEach(m => {
          const type = (m.fields && m.fields['Type']) || '';
          const stip = document.createElement('span');
          stip.className = 'portaal-kalender__dag-stip';
          if (type === 'Verjaardag') stip.classList.add('portaal-kalender__dag-stip--verjaardag');
          else if (type === 'Jubileum' || type === 'Werkjubileum') stip.classList.add('portaal-kalender__dag-stip--jubileum');
          else stip.classList.add('portaal-kalender__dag-stip--overig');
          stippenRij.appendChild(stip);
        });
        if (momentenOpDag.length > maxStippen) {
          const meer = document.createElement('span');
          meer.className = 'portaal-kalender__dag-meer';
          meer.textContent = `+${momentenOpDag.length - maxStippen}`;
          stippenRij.appendChild(meer);
        }
        dagEl.appendChild(stippenRij);

        // Tooltip met namen en type, zodat hover/long-press snel
        // duidelijk maakt wie er die dag een moment heeft.
        const tooltipLijst = momentenOpDag.map(m => {
          const f = m.fields || {};
          const naam = (typeof medewerkerNaamUit === 'function')
            ? medewerkerNaamUit(f['Medewerker'])
            : '—';
          return `${naam} — ${f['Type'] || 'Moment'}`;
        }).join('\n');
        dagEl.title = tooltipLijst;

        dagEl.addEventListener('click', () => toonMomentenVanDag(momentenOpDag, datumStr));
      }

      dagenGrid.appendChild(dagEl);
    }

    container._jaar  = jaar;
    container._maand = maand;
  }

  renderKalender(container._jaar, container._maand);

  if (!container.dataset.kalenderInit) {
    container.dataset.kalenderInit = '1';

    const vorigeKnop   = container.querySelector('#kalender-vorige');
    const volgendeKnop = container.querySelector('#kalender-volgende');

    if (vorigeKnop) {
      vorigeKnop.addEventListener('click', () => {
        let j = container._jaar, m = container._maand - 1;
        if (m < 0) { m = 11; j--; }
        renderKalender(j, m);
      });
    }
    if (volgendeKnop) {
      volgendeKnop.addEventListener('click', () => {
        let j = container._jaar, m = container._maand + 1;
        if (m > 11) { m = 0; j++; }
        renderKalender(j, m);
      });
    }
  }
}

/* ── Momenten van dag tonen ───────────────────────────────── */
function toonMomentenVanDag(momenten, datumStr) {
  const lijst = document.getElementById('momenten-sidebar-lijst');
  if (!lijst) return;

  const header = document.getElementById('momenten-sidebar-header');
  if (header) header.textContent = formatDatum(datumStr);

  // "← Alle momenten" terug-knop bovenaan, zodat de gebruiker niet
  // vastzit op één dag. Klik herstelt de sidebar naar de standaard
  // "aankomende momenten"-lijst.
  const terugKnop = `
    <button type="button" class="portaal-momenten-terug" onclick="resetMomentenSidebar()" aria-label="Terug naar alle momenten">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
      <span>Alle momenten</span>
    </button>`;

  lijst.innerHTML = terugKnop + momenten.map(m => {
    const f = m.fields || {};
    const cadeau = cadeauStatusVoorMoment(f);
    return `
      <div class="portaal-moment-item">
        <div class="portaal-moment-item__naam">${escHtml(medewerkerNaamUit(f['Medewerker']))}</div>
        <div class="portaal-moment-item__badges">
          ${badgeType(f['Type'])}
          ${badgeStatus(f['Status'])}
        </div>
        ${cadeau
          ? `<div class="portaal-moment-item__cadeau${cadeau.viaService ? ' portaal-moment-item__cadeau--service' : ''}">
               ${cadeau.viaService ? '✓ ' : ''}${escHtml(cadeau.label)}
             </div>`
          : ''
        }
      </div>
    `;
  }).join('');
}

/* ── Sidebar terugzetten naar 'alle aankomende momenten' ───── */
function resetMomentenSidebar() {
  const sidebarLijst = document.getElementById('momenten-sidebar-lijst');
  const header       = document.getElementById('momenten-sidebar-header');
  if (!sidebarLijst) return;

  if (header) header.textContent = 'Aankomende momenten';

  // Gebruik de records die al in geheugen staan (gevuld door laadMomenten).
  const records = (typeof window !== 'undefined' && window._kalenderMomenten) || [];
  renderAankomendeMomentenSidebar(records);
}

/* Render-helper: vult de sidebar met de eerstvolgende 6 aankomende
   momenten. Gedeeld tussen laadMomenten() en resetMomentenSidebar(). */
function renderAankomendeMomentenSidebar(records) {
  const sidebarLijst = document.getElementById('momenten-sidebar-lijst');
  if (!sidebarLijst) return;

  const vandaag = new Date().toISOString().split('T')[0];
  const aankomend = (records || []).filter(r => {
    const d = r.fields && r.fields['Datum'] ? r.fields['Datum'].split('T')[0] : '';
    return d >= vandaag;
  }).slice(0, 6);

  if (aankomend.length === 0) {
    sidebarLijst.innerHTML =
      `<div style="padding:20px 18px;font-size:0.9rem;color:var(--portaal-tekst-muted);">Geen aankomende momenten.</div>`;
    return;
  }

  sidebarLijst.innerHTML = aankomend.map(r => {
    const f = r.fields || {};
    const cadeau = cadeauStatusVoorMoment(f);

    return `
      <div class="portaal-moment-item">
        <div class="portaal-moment-item__datum">${formatDatum(f['Datum'])}</div>
        <div class="portaal-moment-item__naam">${escHtml(medewerkerNaamUit(f['Medewerker']))}</div>
        <div class="portaal-moment-item__badges">${badgeType(f['Type'])}${badgeStatus(f['Status'])}</div>
        ${cadeau
          ? `<div class="portaal-moment-item__cadeau${cadeau.viaService ? ' portaal-moment-item__cadeau--service' : ''}">
               ${cadeau.viaService ? '✓ ' : '🎁 '}${escHtml(cadeau.label)}
             </div>`
          : `<div class="portaal-moment-item__geen-product">
               <span style="color:var(--portaal-tekst-muted);font-size:0.85rem;">Geen cadeau</span>
             </div>`
        }
      </div>`;
  }).join('');
}

/* ── Checkout ──────────────────────────────────────────── */
async function addToCart(variantId, quantity = 1) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity })
    });

    if (!response.ok) throw new Error('Toevoegen mislukt');
    toonToast('Product toegevoegd aan checkout', 'sukses');
    setTimeout(() => { window.location.href = '/cart'; }, 1200);
  } catch (err) {
    toonToast('Fout bij toevoegen aan checkout', 'fout');
  }
}

/* ── Datum formatteren ────────────────────────────────────── */
function formatDatum(dateString) {
  if (!dateString) return '—';
  const datum = new Date(dateString);
  if (isNaN(datum.getTime())) return dateString;

  const maanden = [
    'januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december'
  ];

  return `${datum.getDate()} ${maanden[datum.getMonth()]} ${datum.getFullYear()}`;
}

/* Korte notatie voor tabelweergave: 20-05-1990 */
function formatDatumKort(dateString) {
  if (!dateString) return '—';
  const datum = new Date(dateString);
  if (isNaN(datum.getTime())) return dateString;
  const dd = String(datum.getDate()).padStart(2, '0');
  const mm = String(datum.getMonth() + 1).padStart(2, '0');
  const yyyy = datum.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

/* ── Bedrag formatteren ───────────────────────────────────── */
function formatBedrag(amount) {
  if (amount === null || amount === undefined) return '€ 0,00';
  const getal = parseFloat(amount);
  if (isNaN(getal)) return '€ 0,00';
  return '€ ' + getal.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

/* ── Foto-loader helpers ──────────────────────────────────────
   Patroon: een .portaal-foto wrapper rond een <img>. CSS toont
   een spinner zolang de wrapper geen data-status heeft, en faded
   de <img> in als status="geladen". Bij een fout (404, broken
   URL) toont CSS een dezent placeholder-icoontje. */

/* Render-helper: bouwt de wrapper + img tag als HTML-string.
   Gebruik in template literals i.p.v. een losse <img>. Geeft
   altijd een vaste oppervlakte terug (CSS aspect-ratio op de
   parent), waardoor er geen layout shift is bij het laden. */
function fotoTagMetLoader(opts) {
  const src = opts && opts.src ? String(opts.src) : '';
  const handle = opts && opts.handle ? String(opts.handle) : '';
  const alt = opts && opts.alt ? String(opts.alt) : '';
  const extraImgAttr = opts && opts.imgAttr ? String(opts.imgAttr) : '';
  const wrapperAttr = opts && opts.wrapperAttr ? String(opts.wrapperAttr) : '';
  // Spinner-only wrapper als noch src noch handle bekend is (zeldzaam):
  // de img wordt later via setFotoSrc() of door _laadShopifyFotoFallback ingevuld.
  let imgHtml = '';
  if (src) {
    imgHtml = `<img src="${escHtml(src)}" alt="${escHtml(alt)}" loading="lazy" ${extraImgAttr}>`;
  } else if (handle) {
    imgHtml = `<img data-shopify-handle="${escHtml(handle)}" alt="${escHtml(alt)}" loading="lazy" ${extraImgAttr}>`;
  } else {
    // Geen bron bekend → meteen als 'fout' (placeholder-icoon) tonen.
    return `<span class="portaal-foto" data-status="fout" ${wrapperAttr}></span>`;
  }
  return `<span class="portaal-foto" ${wrapperAttr}>${imgHtml}</span>`;
}

/* Hangt load/error listeners op alle <img>'s binnen `root` die in
   een .portaal-foto wrapper zitten. Veilig om meerdere keren aan
   te roepen op dezelfde container (we gebruiken data-foto-init). */
function initFotoLoaders(root) {
  const scope = root || document;
  const imgs = scope.querySelectorAll('.portaal-foto img:not([data-foto-init])');
  imgs.forEach(img => {
    img.setAttribute('data-foto-init', '1');
    const wrapper = img.closest('.portaal-foto');
    if (!wrapper) return;
    const markeer = (status) => wrapper.setAttribute('data-status', status);
    // complete=true betekent dat de browser de img al uit cache haalde
    // vóór de listener gehangen was — direct als geladen markeren.
    if (img.complete && img.naturalWidth > 0) {
      markeer('geladen');
    } else if (img.complete && img.naturalWidth === 0 && img.src) {
      markeer('fout');
    } else {
      img.addEventListener('load', () => markeer('geladen'), { once: true });
      img.addEventListener('error', () => markeer('fout'), { once: true });
    }
  });
}

/* Vervangt de src van een img inside een .portaal-foto wrapper en
   reset de status zodat de spinner opnieuw verschijnt tot de
   nieuwe foto klaar is. */
function setFotoSrc(img, nieuweUrl) {
  if (!img) return;
  const wrapper = img.closest('.portaal-foto');
  if (wrapper) wrapper.removeAttribute('data-status');
  img.removeAttribute('data-foto-init');
  img.src = nieuweUrl;
  initFotoLoaders(wrapper || img.parentElement);
}

/* ── Pagina-loader overlay ─────────────────────────────────────
   Toont een fixed overlay met spinner. Aanroepen vóór async
   data-fetches en weghalen zodra de pagina render-klaar is. */
function toonPaginaLoader() {
  if (document.getElementById('portaal-pagina-loader')) return;
  const overlay = document.createElement('div');
  overlay.id = 'portaal-pagina-loader';
  overlay.className = 'portaal-pagina-loader';
  overlay.setAttribute('role', 'status');
  overlay.setAttribute('aria-live', 'polite');
  overlay.setAttribute('aria-label', 'Pagina wordt geladen');
  overlay.innerHTML = '<div class="portaal-pagina-loader__spinner" aria-hidden="true"></div>';
  document.body.appendChild(overlay);
}

function verbergPaginaLoader() {
  const overlay = document.getElementById('portaal-pagina-loader');
  if (!overlay) return;
  overlay.hidden = true;
  // CSS faded uit; na transitie verwijderen.
  setTimeout(() => overlay.remove(), 250);
}

// Exposeren als window-globals zodat sections (inline scripts) ze
// ook kunnen aanroepen.
if (typeof window !== 'undefined') {
  window.fotoTagMetLoader = fotoTagMetLoader;
  window.initFotoLoaders = initFotoLoaders;
  window.setFotoSrc = setFotoSrc;
  window.toonPaginaLoader = toonPaginaLoader;
  window.verbergPaginaLoader = verbergPaginaLoader;
}

/* ── HTML escapen ─────────────────────────────────────────── */
function escHtml(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/* ── Toast ────────────────────────────────────────────────── */
function toonToast(bericht, type = '') {
  let toast = document.getElementById('portaal-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'portaal-toast';
    toast.className = 'portaal-toast';
    document.body.appendChild(toast);
  }

  toast.textContent = bericht;
  toast.className = `portaal-toast ${type}`;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => { toast.classList.add('toon'); });
  });

  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => { toast.classList.remove('toon'); }, 3400);
}

/* ── Badge helpers ────────────────────────────────────────── */
function badgeType(type) {
  const map = {
    'Verjaardag': 'blauw',
    'Jubileum': 'goud',
    'Seizoen': 'groen',
    'Anders': 'grijs'
  };
  const klasse = map[type] || 'grijs';
  return type ? `<span class="portaal-badge portaal-badge--${klasse}">${escHtml(type)}</span>` : '';
}

function badgeStatus(status) {
  const map = {
    'Gepland': 'grijs',
    'Besteld': 'blauw',
    'Verzonden': 'paars',
    'Bezorgd': 'groen',
    'Open': 'oranje',
    'Betaald': 'groen',
    'Verlopen': 'rood'
  };
  const klasse = map[status] || 'grijs';
  return status ? `<span class="portaal-badge portaal-badge--${klasse}">${escHtml(status)}</span>` : '';
}

/* ── CSV Drag & Drop ──────────────────────────────────────── */
function initUploadZone(zoneId, inputId) {
  const zone = document.getElementById(zoneId);
  const input = document.getElementById(inputId);
  if (!zone || !input) return;

  // Click-opening alleen toevoegen als de zone GEEN <label for=...> is.
  // Een <label> opent het bestand-veld al native; dat is robuuster (werkt
  // ook als JS niet draait of pas later geladen wordt). Een tweede
  // input.click() zou de file picker twee keer triggeren.
  if (zone.tagName !== 'LABEL') {
    zone.addEventListener('click', () => input.click());
  }

  zone.addEventListener('dragover', (e) => {
    e.preventDefault();
    zone.classList.add('drag-over');
  });

  zone.addEventListener('dragleave', () => zone.classList.remove('drag-over'));

  zone.addEventListener('drop', (e) => {
    e.preventDefault();
    zone.classList.remove('drag-over');
    if (e.dataTransfer.files.length) {
      input.files = e.dataTransfer.files;
      const naam = e.dataTransfer.files[0].name;
      const tekstEl = zone.querySelector('.portaal-upload-zone__tekst');
      if (tekstEl) tekstEl.textContent = naam;
      zone.classList.add('has-file');
    }
  });

  input.addEventListener('change', () => {
    if (input.files.length) {
      const tekstEl = zone.querySelector('.portaal-upload-zone__tekst');
      if (tekstEl) tekstEl.textContent = input.files[0].name;
      zone.classList.add('has-file');
    } else {
      zone.classList.remove('has-file');
    }
  });
}

/* ── Klant Record ID ophalen ──────────────────────────────── */
// Cache zodat we niet elke fetch een extra request doen.
const _klantIdCache = {};

async function vindKlantRecordId(klantEmail) {
  if (!klantEmail) return null;
  if (_klantIdCache[klantEmail] !== undefined) return _klantIdCache[klantEmail];

  const records = await fetchAirtable('Klanten', `{Customer Email} = "${klantEmail}"`);
  const id = records.length > 0 ? records[0].id : null;
  _klantIdCache[klantEmail] = id;
  return id;
}

// Bouwt een filter die zowel via het 'Klant' tekst-veld matcht (oude records)
// als via de 'Klanten' linked record (nieuwe records).
function bouwMedewerkerFilter(klantEmail, klantRecordId) {
  if (klantRecordId) {
    return `OR({Klant} = "${klantEmail}", FIND("${klantRecordId}", ARRAYJOIN({Klanten})))`;
  }
  return `{Klant} = "${klantEmail}"`;
}

/* ── Stats laden (dashboard) ──────────────────────────────── */
async function laadDashboardStats(klantEmail) {
  if (!klantEmail || !PORTAAL_CONFIG.airtableBaseId) return;

  const klantId = await vindKlantRecordId(klantEmail);

  const medewerkers = await fetchAirtable('Medewerkers', bouwMedewerkerFilter(klantEmail, klantId));
  actualiseerStat('stat-medewerkers', medewerkers.length);

  const nu = new Date();
  const eersteVanMaand = new Date(nu.getFullYear(), nu.getMonth(), 1).toISOString().split('T')[0];
  const laasteVanMaand = new Date(nu.getFullYear(), nu.getMonth() + 1, 0).toISOString().split('T')[0];

  // Geplande Momenten heeft geen 'Klant Email' veld; we filteren via linked record.
  const momentenFilter = klantId
    ? `AND(FIND("${klantId}", ARRAYJOIN({Klanten})), IS_AFTER({Datum}, "${eersteVanMaand}"), IS_BEFORE({Datum}, "${laasteVanMaand}"))`
    : `AND(FALSE())`;
  const momenten = await fetchAirtable('Geplande Momenten', momentenFilter);
  actualiseerStat('stat-momenten', momenten.length);

  const facturen = await fetchAirtable(
    'Maandfacturen',
    `AND({Klant Email} = "${klantEmail}", OR({Betaalstatus} = "Open", {Betaalstatus} = "Verlopen"))`
  );
  actualiseerStat('stat-facturen', facturen.length);
}

function actualiseerStat(elementId, waarde) {
  const el = document.getElementById(elementId);
  if (!el) return;
  el.textContent = waarde;
  el.classList.add('geladen');
}

/* ── Medewerkers tabel laden ──────────────────────────────── */
// Paginatie-state — module-scope zodat de page-size selector & vorige/volgende
// knoppen werken zonder dat we de records opnieuw uit Airtable hoeven te halen.
const MEDEWERKERS_PER_PAGE_OPTIES = [10, 25, 50, 100];
const MEDEWERKERS_PER_PAGE_DEFAULT = 25;
let _medewerkersState = {
  records: [],
  page: 1,
  perPage: MEDEWERKERS_PER_PAGE_DEFAULT,
  containerId: null,
  query: '',
};

// Filtert records op de huidige zoekterm. Match is case-insensitive op
// Naam, E-mail, Stad, Land en Opmerking (Notities-veld). Lege query
// betekent: alle records.
function _filterMedewerkers(records, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return records;
  return records.filter(r => {
    const f = r.fields || {};
    const haystack = [
      f['Naam'], f['E-mail'], f['Stad'], f['Land'], f['Notities']
    ].filter(Boolean).join(' ').toLowerCase();
    return haystack.includes(q);
  });
}

// Eenmalig event-delegation aan de tabel-container hangen.
// We doen dit op de stabiele wrapper (containerId), niet op de tbody —
// die wordt bij elke re-render vervangen, waardoor losse handlers zouden
// verdwijnen. Eén handler op de wrapper overleeft alle re-renders.
function initMedewerkersDelegation(container) {
  if (!container || container.dataset.delegationInit === '1') return;
  container.dataset.delegationInit = '1';

  // Click: rij-bekijken, of actie-knop (bewerken/verwijderen).
  // closest() levert de DICHTSTBIJZIJNDE match — een klik op de
  // potlood-knop binnen een klikbare rij triggert dus de knop-actie,
  // niet de rij-actie. Geen extra stopPropagation nodig.
  container.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-medewerker-actie]');
    if (!knop) return;
    const actie = knop.dataset.medewerkerActie;
    const recordId = knop.dataset.recordId;
    if (!recordId) return;
    if (actie === 'bewerken' || actie === 'bekijken') {
      openMedewerkerModalById(recordId);
    } else if (actie === 'verwijderen') {
      verwijderMedewerker(recordId);
    }
  });

  // Keyboard: Enter of Spatie op een rij opent het modaal (toegankelijkheid).
  container.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const rij = e.target.closest('tr[data-medewerker-actie="bekijken"]');
    if (!rij) return;
    e.preventDefault();
    const recordId = rij.dataset.recordId;
    if (recordId) openMedewerkerModalById(recordId);
  });
}

async function laadMedewerkers(klantEmail, containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  initMedewerkersDelegation(container);

  container.innerHTML = '<div class="portaal-loader"></div>';

  // In proxy mode is alle config server-side; we hoeven niets te checken.
  // In legacy mode kan het zijn dat initPortaal() nog niet gerunt heeft —
  // dan wachten we kort en proberen we opnieuw, in plaats van direct
  // "Airtable nog niet gekoppeld" te tonen (dat schrok klanten af).
  if (!PORTAAL_CONFIG.useProxy && !PORTAAL_CONFIG.airtableBaseId) {
    // Wacht tot 2 seconden op initPortaal() om de config te zetten.
    let pogingen = 0;
    while (!PORTAAL_CONFIG.airtableBaseId && pogingen < 20) {
      await new Promise(r => setTimeout(r, 100));
      pogingen++;
    }
    if (!PORTAAL_CONFIG.airtableBaseId) {
      container.innerHTML = `
        <div class="portaal-leeg">
          <p class="portaal-leeg__tekst">De medewerkers-database kan nu niet bereikt worden. Probeer over een minuut nogmaals, of neem contact op met Secret Gifters als dit aanhoudt.</p>
        </div>`;
      return;
    }
  }

  const klantId = await vindKlantRecordId(klantEmail);
  const records = await fetchAirtable('Medewerkers', bouwMedewerkerFilter(klantEmail, klantId), 'Naam');

  const zoekWrapper = document.getElementById('medewerkers-zoek-wrapper');

  if (records.length === 0) {
    if (zoekWrapper) zoekWrapper.style.display = 'none';
    // Lege lijst door een fout (401/5xx/geen verbinding) is iets anders dan
    // "nog geen medewerkers". portaal-secure.js zet _PORTAAL_LAATSTE_FOUT en
    // toont bovenaan al een banner; hier geen misleidende lege-staat tonen.
    const fout = window._PORTAAL_LAATSTE_FOUT;
    if (fout) {
      container.innerHTML = `
        <div class="portaal-leeg">
          <p class="portaal-leeg__tekst">Je medewerkers konden niet geladen worden${fout.status ? ` (fout ${fout.status})` : ''}.<br>Zie de melding bovenaan de pagina.</p>
        </div>`;
      return;
    }
    container.innerHTML = `
      <div class="portaal-leeg">
        <p class="portaal-leeg__tekst">Nog geen medewerkers toegevoegd.<br>Voeg je eerste medewerker toe of importeer via CSV.</p>
      </div>`;
    return;
  }

  // Zoekbalk pas tonen als er records zijn (toont niet onnodig in lege state).
  if (zoekWrapper) zoekWrapper.style.display = '';

  // Reset page naar 1 bij herladen; perPage onthouden als er al een keuze was
  // gemaakt (zodat na "medewerker toevoegen" de gekozen page-size blijft).
  // Query onthouden zodat een refresh na een wijziging het filter behoudt.
  _medewerkersState = {
    records,
    page: 1,
    perPage: _medewerkersState.perPage || MEDEWERKERS_PER_PAGE_DEFAULT,
    containerId,
    query: _medewerkersState.query || '',
  };
  _renderMedewerkersPagina();
}

// Aangeroepen door oninput van de zoekbalk. Reset pagina naar 1 bij elk
// nieuw zoekwoord; we willen niet dat de gebruiker op pagina 4 blijft staan
// terwijl het filter slechts 5 resultaten oplevert.
function zoekMedewerkers(query) {
  _medewerkersState.query = query || '';
  _medewerkersState.page = 1;
  _renderMedewerkersPagina();
}

function _renderMedewerkersPagina() {
  const { records, page, perPage, containerId, query } = _medewerkersState;
  const container = document.getElementById(containerId);
  if (!container) return;

  // Eerst filteren, dan pagineren — zo blijven tellingen consistent.
  const gefilterd = _filterMedewerkers(records, query);
  const totaal = gefilterd.length;
  const totaalPaginas = Math.max(1, Math.ceil(totaal / perPage));
  const huidigePagina = Math.min(Math.max(1, page), totaalPaginas);
  _medewerkersState.page = huidigePagina;

  const start = (huidigePagina - 1) * perPage;
  const slice = gefilterd.slice(start, start + perPage);

  // Lege filter-resultaten: nette melding ipv lege tabel.
  if (totaal === 0 && (query || '').trim()) {
    container.innerHTML = `
      <div class="portaal-leeg">
        <p class="portaal-leeg__tekst">Geen medewerkers gevonden voor "<strong>${escHtml(query)}</strong>". Probeer een ander zoekwoord.</p>
      </div>`;
    return;
  }

  const iconPotlood = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>';
  const iconPrullenbak = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>';
  const iconNotitie = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/></svg>';

  const rijen = slice.map(r => {
    const f = r.fields || {};
    // Geen inline onclick meer — we gebruiken event delegation
    // (zie initMedewerkersDelegation). De rij is in zijn geheel klikbaar
    // (opent het detail-/bewerk-modaal); alleen de actie-knoppen rechts
    // hebben hun eigen handler.

    const leef = leeftijdVanDatum(f['Geboortedatum']);
    const gebStr = formatDatumKort(f['Geboortedatum']);
    const startStr = f['Startdatum'] ? formatDatumKort(f['Startdatum']) : '';
    const geboorteCel = gebStr
      ? `<div>${gebStr}</div>`
      : '<span style="color:#9ca3af;">—</span>';
    const leeftijdCel = leef !== null
      ? `${leef}`
      : '<span style="color:#9ca3af;">—</span>';
    const geslachtCel = f['Geslacht']
      ? escHtml(f['Geslacht'])
      : '<span style="color:#9ca3af;">—</span>';
    const dienstCel = startStr
      ? `<div>${startStr}</div>`
      : '<span style="color:#9ca3af;">—</span>';

    const rid = escHtml(r.id);
    return `
      <tr data-record-id="${rid}" data-medewerker-actie="bekijken" tabindex="0"
          role="button" aria-label="Bekijk alle gegevens van ${escHtml(f['Naam'] || 'deze medewerker')}">
        <td class="portaal-tabel__naam-cel"><span class="portaal-tabel__naam">${escHtml(f['Naam'] || '—')}</span></td>
        <td>${escHtml(f['E-mail'] || '—')}</td>
        <td>${geboorteCel}</td>
        <td>${leeftijdCel}</td>
        <td>${geslachtCel}</td>
        <td>${dienstCel}</td>
        <td class="portaal-tabel__actie-cel">
          <div class="portaal-actie-icons">
            <button type="button" class="portaal-icon-knop"
                    data-medewerker-actie="bewerken" data-record-id="${rid}"
                    title="Bewerken" aria-label="Medewerker bewerken">
              ${iconPotlood}
            </button>
            <button type="button" class="portaal-icon-knop portaal-icon-knop--danger"
                    data-medewerker-actie="verwijderen" data-record-id="${rid}"
                    title="Verwijderen" aria-label="Medewerker verwijderen">
              ${iconPrullenbak}
            </button>
          </div>
        </td>
      </tr>`;
  }).join('');

  // Eerste & laatste rij-nummer (1-based, voor "1–25 van 95"-tekst).
  const eersteRij = totaal === 0 ? 0 : start + 1;
  const laatsteRij = Math.min(start + perPage, totaal);

  // Page-size dropdown opties — gegenereerd uit MEDEWERKERS_PER_PAGE_OPTIES,
  // zodat we de keuzes op één plek bijwerken als ze ooit veranderen.
  const perPageOpties = MEDEWERKERS_PER_PAGE_OPTIES.map(n => (
    `<option value="${n}"${n === perPage ? ' selected' : ''}>${n}</option>`
  )).join('');

  const vorigeUit = huidigePagina <= 1 ? ' disabled' : '';
  const volgendeUit = huidigePagina >= totaalPaginas ? ' disabled' : '';

  const navHtml = `
    <div class="portaal-paginatie">
      <div class="portaal-paginatie__info">
        <label for="medewerkers-per-pagina">Toon</label>
        <select id="medewerkers-per-pagina"
                class="portaal-paginatie__select"
                onchange="zetMedewerkersPerPagina(this.value)"
                aria-label="Aantal medewerkers per pagina">
          ${perPageOpties}
        </select>
        <span class="portaal-paginatie__bereik">${eersteRij}–${laatsteRij} van ${totaal}</span>
      </div>
      <div class="portaal-paginatie__nav" role="navigation" aria-label="Paginatie">
        <button type="button" class="portaal-paginatie__knop"
                onclick="gaNaarMedewerkersPagina(${huidigePagina - 1})"${vorigeUit}
                aria-label="Vorige pagina">← Vorige</button>
        <span class="portaal-paginatie__teller" aria-live="polite">
          Pagina ${huidigePagina} van ${totaalPaginas}
        </span>
        <button type="button" class="portaal-paginatie__knop"
                onclick="gaNaarMedewerkersPagina(${huidigePagina + 1})"${volgendeUit}
                aria-label="Volgende pagina">Volgende →</button>
      </div>
    </div>`;

  container.innerHTML = `
    <p class="portaal-tabel-hint" aria-hidden="true">
      Klik op een rij om alle gegevens van een medewerker te bekijken.
    </p>
    ${navHtml}
    <div class="portaal-tabel-wrapper">
      <table class="portaal-tabel portaal-tabel--compact portaal-tabel--sticky-acties portaal-tabel--klikbaar">
        <thead>
          <tr>
            <th>Naam</th>
            <th>E-mail</th>
            <th>Geboortedatum</th>
            <th>Leeftijd</th>
            <th>Geslacht</th>
            <th>In dienst</th>
            <th class="portaal-tabel__actie-cel" style="width:90px;">Acties</th>
          </tr>
        </thead>
        <tbody>${rijen}</tbody>
      </table>
    </div>
    ${navHtml}`;
}

function gaNaarMedewerkersPagina(nieuw) {
  const n = parseInt(nieuw, 10);
  if (!Number.isFinite(n) || n < 1) return;
  _medewerkersState.page = n;
  _renderMedewerkersPagina();
}

function zetMedewerkersPerPagina(nieuw) {
  const n = parseInt(nieuw, 10);
  if (!MEDEWERKERS_PER_PAGE_OPTIES.includes(n)) return;
  _medewerkersState.perPage = n;
  _medewerkersState.page = 1; // terug naar het begin bij wisselen
  _renderMedewerkersPagina();
}

/* ── Medewerker verwijderen ───────────────────────────────── */
async function verwijderMedewerker(recordId) {
  const ok = await bevestig({
    titel: 'Medewerker verwijderen?',
    tekst: 'Deze actie kan niet ongedaan worden gemaakt. De medewerker wordt definitief uit je overzicht verwijderd.',
    bevestigTekst: 'Ja, verwijderen',
    destructief: true
  });
  if (!ok) return;

  const succes = await deleteAirtableRecord('Medewerkers', recordId);
  if (succes) {
    toonToast('Medewerker verwijderd', 'sukses');
    const pagina = document.getElementById('portaal-team-pagina');
    const klantEmail = pagina ? (pagina.dataset.klantEmail || '') : '';
    if (klantEmail) await laadMedewerkers(klantEmail, 'medewerkers-tabel-container');
  } else {
    toonToast('Fout bij verwijderen', 'fout');
  }
}

/* ── Leeftijd uit geboortedatum berekenen ─────────────────── */
// Wordt zowel in de tabel-render als in het modaal gebruikt. Retourneert
// een getal (>=0) of null als de datum ongeldig is of in de toekomst ligt.
function leeftijdVanDatum(isoDatum) {
  if (!isoDatum) return null;
  const geb = new Date(isoDatum);
  if (Number.isNaN(geb.getTime())) return null;
  const nu = new Date();
  let leef = nu.getFullYear() - geb.getFullYear();
  const maand = nu.getMonth() - geb.getMonth();
  if (maand < 0 || (maand === 0 && nu.getDate() < geb.getDate())) leef--;
  if (leef < 0 || leef > 130) return null;
  return leef;
}

// Vult het read-only Leeftijd-veld in het medewerker-modaal op basis van
// de huidige Geboortedatum-input. Aangeroepen via oninput op het datum-veld.
function updateLeeftijdVeld() {
  const geb = document.getElementById('veld-geboortedatum');
  const leef = document.getElementById('veld-leeftijd');
  if (!geb || !leef) return;
  const n = leeftijdVanDatum(geb.value);
  leef.value = n === null ? '' : `${n} jaar`;
}

/* ── Medewerker modal openen via record-id ────────────────── */
// Zoekt het record op in de in-memory state en opent het bewerk-modaal.
// Wordt gebruikt door de tabel-actie-knoppen om te voorkomen dat we de
// volledige fields-JSON inline in een HTML-attribuut moeten serializen
// (dat brak als Notities/Opmerking aanhalingstekens of newlines bevatte).
function openMedewerkerModalById(recordId) {
  const record = (_medewerkersState.records || []).find(r => r.id === recordId);
  if (!record) {
    toonToast('Medewerker niet gevonden. Probeer de pagina te herladen.', 'fout');
    return;
  }
  openMedewerkerModal(recordId, record.fields || {});
}

/* ── Medewerker modal openen ──────────────────────────────── */
function openMedewerkerModal(recordId = null, fields = null) {
  const modal = document.getElementById('medewerker-modal-overlay');
  if (!modal) return;

  const titelEl = modal.querySelector('.portaal-modal__titel');
  const form = modal.querySelector('#medewerker-form');
  if (!form) return;

  if (recordId && fields) {
    if (titelEl) titelEl.textContent = 'Medewerker bewerken';
    form.dataset.recordId = recordId;
    const waarden = {
      'veld-naam': fields['Naam'] || '',
      'veld-email': fields['E-mail'] || '',
      'veld-geboortedatum': fields['Geboortedatum'] || '',
      'veld-startdatum': fields['Startdatum'] || '',
      'veld-adres': fields['Adres'] || '',
      'veld-postcode': fields['Postcode'] || '',
      'veld-stad': fields['Stad'] || '',
      'veld-land': fields['Land'] || 'Nederland',
      'veld-geslacht': fields['Geslacht'] || '',
      'veld-opmerking': fields['Notities'] || '',
    };
    Object.entries(waarden).forEach(([id, val]) => {
      const el = form.querySelector(`#${id}`);
      if (el) el.value = val;
    });
  } else {
    if (titelEl) titelEl.textContent = 'Medewerker toevoegen';
    delete form.dataset.recordId;
    form.reset();
    // Bij toevoegen: Nederland default, opmerking/leeftijd leeg.
    const landEl = form.querySelector('#veld-land');
    if (landEl) landEl.value = 'Nederland';
  }
  // Leeftijd berekenen na elke open
  updateLeeftijdVeld();

  openModal('medewerker-modal-overlay');
}

/* ── Moment modal openen ──────────────────────────────────── */
function openMomentModal(recordId = null, fields = null) {
  const modal = document.getElementById('moment-modal-overlay');
  if (!modal) return;

  const titelEl = modal.querySelector('.portaal-modal__titel');
  const form = modal.querySelector('#moment-form');
  if (!form) return;

  if (recordId && fields) {
    if (titelEl) titelEl.textContent = 'Moment bewerken';
    form.dataset.recordId = recordId;

    const recordIdInput = form.querySelector('#moment-record-id');
    if (recordIdInput) recordIdInput.value = recordId;

    const typeSelect = form.querySelector('#moment-type');
    const datumInput = form.querySelector('#moment-datum');
    const berichtInput = form.querySelector('#moment-bericht');

    if (typeSelect && fields['Type']) typeSelect.value = fields['Type'];
    if (datumInput && fields['Datum']) datumInput.value = fields['Datum'].split('T')[0];
    if (berichtInput && (fields['Persoonlijk bericht'] || fields['Bericht'])) {
      berichtInput.value = fields['Persoonlijk bericht'] || fields['Bericht'];
    }

    const medewerkerSelect = form.querySelector('#moment-medewerker');
    if (medewerkerSelect && fields['Medewerker']) {
      const medId = Array.isArray(fields['Medewerker']) ? fields['Medewerker'][0] : fields['Medewerker'];
      medewerkerSelect.value = medId;
    }
  } else {
    if (titelEl) titelEl.textContent = 'Moment inplannen';
    delete form.dataset.recordId;
    const recordIdInput = form.querySelector('#moment-record-id');
    if (recordIdInput) recordIdInput.value = '';
    form.reset();
  }

  openModal('moment-modal-overlay');
}

/* ── Momenten laden ───────────────────────────────────────── */
async function laadMomenten(klantEmail) {
  const container = document.getElementById('momenten-lijst-container');
  const sidebarLijst = document.getElementById('momenten-sidebar-lijst');

  // Initialiseer kalender altijd (ook als er geen momenten zijn)
  initKalender('portaal-kalender', []);

  if (container) container.innerHTML = '<div class="portaal-loader"></div>';
  if (sidebarLijst) sidebarLijst.innerHTML = '<div class="portaal-loader"></div>';

  if (!PORTAAL_CONFIG.useProxy && !PORTAAL_CONFIG.airtableBaseId) {
    const leegMsg = `<div class="portaal-leeg"><p class="portaal-leeg__tekst">Koppel Airtable om momenten te laden.</p></div>`;
    if (container) container.innerHTML = leegMsg;
    if (sidebarLijst) sidebarLijst.innerHTML = leegMsg;
    return;
  }

  const klantId = await vindKlantRecordId(klantEmail);
  const filter = klantId
    ? `FIND("${klantId}", ARRAYJOIN({Klanten}))`
    : `FALSE()`;
  // Klant-services parallel laden zodat 'Cadeau gepland via service'
  // kan worden bepaald in de rendering.
  const [alleRecords, _services] = await Promise.all([
    fetchAirtable('Geplande Momenten', filter, 'Datum', 'asc'),
    laadKlantServices(),
  ]);
  // Filter momenten op service-status: een verjaardag-moment is alleen
  // 'gepland' als de verjaardagsservice ook actief is. Zet de service uit
  // → de bijbehorende momenten verdwijnen uit kalender en sidebar.
  const records = filterMomentenOpService(alleRecords);
  window._kalenderMomenten = records;

  // Update kalender met de geladen momenten
  initKalender('portaal-kalender', records);

  // Sidebar: toon aankomende momenten (gedeelde helper — wordt ook
  // gebruikt door de "← Alle momenten"-knop in toonMomentenVanDag).
  if (sidebarLijst) {
    renderAankomendeMomentenSidebar(records);
  }

  if (!container) return;

  if (records.length === 0) {
    container.innerHTML = `
      <div class="portaal-leeg">
        <p class="portaal-leeg__tekst">Nog geen momenten gepland.<br>Klik op "Moment inplannen" om te beginnen.</p>
      </div>`;
    return;
  }

  container.innerHTML = records.map(r => {
    const f = r.fields || {};
    const fieldsJson = escHtml(JSON.stringify(f));
    const cadeau = cadeauStatusVoorMoment(f);

    return `
      <div class="portaal-moment-item" data-type="${escHtml(f['Type'] || '')}">
        <div class="portaal-moment-item__datum">${formatDatum(f['Datum'])}</div>
        <div class="portaal-moment-item__naam">${escHtml(medewerkerNaamUit(f['Medewerker']))}</div>
        <div class="portaal-moment-item__badges">
          ${badgeType(f['Type'])}
          ${badgeStatus(f['Status'])}
        </div>
        ${cadeau
          ? `<div class="portaal-moment-product-card${cadeau.viaService ? ' portaal-moment-product-card--service' : ''}">
               <div class="portaal-moment-product-card__info">
                 <strong>${cadeau.viaService ? '✓' : '🎁'} ${escHtml(cadeau.label)}</strong>
                 ${(!cadeau.viaService && f['Personalisatie Details']) ? `<p class="portaal-moment-product-card__personalisatie">${escHtml(f['Personalisatie Details'])}</p>` : ''}
               </div>
             </div>`
          : `<div class="portaal-moment-geen-product">
               <span>Nog geen cadeau gekozen</span>
               <button class="portaal-knop-goud portaal-knop-sm" onclick="kiesCadeau('${escHtml(r.id)}')">
                 Cadeau kiezen
               </button>
             </div>`
        }
        <div style="margin-top:8px;display:flex;gap:6px;">
          <button class="portaal-knop-navy portaal-knop-sm"
                  onclick="openMomentModal('${escHtml(r.id)}', ${fieldsJson})">
            Bewerken
          </button>
        </div>
      </div>`;
  }).join('');
}

/* ── Facturen tabel laden ─────────────────────────────────── */
async function laadFacturen(klantEmail, containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.innerHTML = '<div class="portaal-loader"></div>';

  if (!PORTAAL_CONFIG.useProxy && !PORTAAL_CONFIG.airtableBaseId) {
    container.innerHTML = `<div class="portaal-leeg"><p class="portaal-leeg__tekst">Koppel Airtable om facturen te laden.</p></div>`;
    return;
  }

  const records = await fetchAirtable('Maandfacturen', `{Klant Email} = "${klantEmail}"`, 'Maand', 'desc');

  if (records.length === 0) {
    container.innerHTML = `
      <div class="portaal-leeg">
        <p class="portaal-leeg__tekst">Nog geen facturen beschikbaar.</p>
      </div>`;
    return;
  }

  // Geen status of betaalknop meer: de betaalstatus wordt bij betaling op
  // rekening niet direct bijgewerkt en toonde dus verouderde info (besluit
  // Job/Nicole aug 2026). De pagina is puur een factuurarchief met PDF's.
  const rijen = records.map(r => {
    const f = r.fields || {};
    const bedrag = f['Totaalbedrag'] ?? f['Bedrag'] ?? 0;
    const pdfUrl = f['PDF URL'] || '#';

    return `
      <tr>
        <td>${escHtml(f['Maand'] || '—')}</td>
        <td>${escHtml(f['Periode'] || '—')}</td>
        <td><strong>${formatBedrag(bedrag)}</strong></td>
        <td>
          ${pdfUrl && pdfUrl !== '#' ? `
            <a href="${escHtml(pdfUrl)}" target="_blank" rel="noopener" class="portaal-knop-navy portaal-knop-sm">
              Download PDF
            </a>` : '—'}
        </td>
      </tr>`;
  }).join('');

  container.innerHTML = `
    <div class="portaal-tabel-wrapper">
      <table class="portaal-tabel">
        <thead>
          <tr>
            <th>Maand</th>
            <th>Periode</th>
            <th>Bedrag</th>
            <th>Factuur</th>
          </tr>
        </thead>
        <tbody>${rijen}</tbody>
      </table>
    </div>`;
}

/* ── Documenten & Contracten laden ───────────────────────── */
async function laadDocumenten(klantEmail, containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.innerHTML = '<div class="portaal-loader"></div>';

  if (!PORTAAL_CONFIG.useProxy && !PORTAAL_CONFIG.airtableBaseId) {
    container.innerHTML = `<div class="portaal-leeg"><p class="portaal-leeg__tekst">Koppel Airtable om documenten te laden.</p></div>`;
    return;
  }

  let records;
  try {
    records = await fetchAirtable('Documenten', `{Klant Email} = "${klantEmail}"`, 'Datum', 'desc');
  } catch (e) {
    container.innerHTML = `<div class="portaal-leeg"><p class="portaal-leeg__tekst">Nog geen documenten beschikbaar.</p></div>`;
    return;
  }

  if (!records || records.length === 0) {
    container.innerHTML = `<div class="portaal-leeg"><p class="portaal-leeg__tekst">Nog geen documenten beschikbaar.</p></div>`;
    return;
  }

  const rijen = records.map(r => {
    const f = r.fields || {};
    const status = f['Status'] || '—';
    const pdfUrl = f['PDF URL'] || f['Bestand URL'] || '';
    const datum = f['Datum'] ? new Date(f['Datum']).toLocaleDateString('nl-NL') : '—';

    return `
      <tr>
        <td>${escHtml(f['Naam'] || '—')}</td>
        <td>${escHtml(f['Type'] || '—')}</td>
        <td>${escHtml(datum)}</td>
        <td>${badgeStatus(status)}</td>
        <td>
          ${pdfUrl ? `
            <a href="${escHtml(pdfUrl)}" target="_blank" rel="noopener" class="portaal-knop-navy portaal-knop-sm">
              Download
            </a>` : '—'}
        </td>
      </tr>`;
  }).join('');

  container.innerHTML = `
    <div class="portaal-tabel-wrapper">
      <table class="portaal-tabel">
        <thead>
          <tr>
            <th>Naam</th>
            <th>Type</th>
            <th>Datum</th>
            <th>Status</th>
            <th>Bestand</th>
          </tr>
        </thead>
        <tbody>${rijen}</tbody>
      </table>
    </div>`;
}

/* ── Medewerker dropdown vullen ───────────────────────────── */
async function vulMedewerkerDropdown(selectId, klantEmail) {
  const select = document.getElementById(selectId);
  if (!select) return;

  if (!PORTAAL_CONFIG.useProxy && !PORTAAL_CONFIG.airtableBaseId) {
    select.innerHTML = '<option value="">— Airtable niet geconfigureerd —</option>';
    return;
  }

  const klantId = await vindKlantRecordId(klantEmail);
  const records = await fetchAirtable('Medewerkers', bouwMedewerkerFilter(klantEmail, klantId), 'Naam');

  // Globale lookup-map zodat elke planning/kalender-view kan zien
  // wie een medewerker is en of er een vast verjaardag-/jubileum-cadeau
  // op de medewerker staat (gebruikt door de auto-cron). Hierdoor kan de
  // UI tonen dat een cadeau "via de service gepland is" ook als er nog
  // geen concreet cadeau aan het moment hangt.
  window._medewerkersById = window._medewerkersById || {};
  records.forEach(r => {
    const f = r.fields || {};
    if (!r.id) return;
    window._medewerkersById[r.id] = {
      naam: f['Naam'] || 'Onbekend',
      cadeauVerjaardag: Array.isArray(f['Cadeau verjaardag']) && f['Cadeau verjaardag'].length > 0,
      cadeauJubileum:   Array.isArray(f['Cadeau jubileum'])   && f['Cadeau jubileum'].length   > 0,
    };
  });

  select.innerHTML = '<option value="">— Kies medewerker —</option>';
  records.forEach(r => {
    const f = r.fields || {};
    const naam = f['Naam'] || 'Onbekend';
    const opt = document.createElement('option');
    opt.value = r.id;
    opt.textContent = naam;
    if (f['Geboortedatum']) opt.dataset.geboortedatum = f['Geboortedatum'].split('T')[0];
    if (f['Startdatum']) opt.dataset.startdatum = f['Startdatum'].split('T')[0];
    select.appendChild(opt);
  });

  if (selectId === 'moment-medewerker') initMomentModalAutoFill();
}

/* Helper: pak het lookup-object voor een 'Medewerker'-veldwaarde.
   Returns null als de medewerker onbekend is. */
function _medewerkerEntryUit(value) {
  const lookup = (typeof window !== 'undefined' && window._medewerkersById) || {};
  let id = null;
  if (Array.isArray(value) && value.length > 0) id = value[0];
  else if (typeof value === 'string' && value && value.startsWith('rec')) id = value;
  return id ? (lookup[id] || null) : null;
}

/* Resolve een 'Medewerker'-veldwaarde (array van linked-record-IDs,
   één ID, of legacy naam-string) naar een leesbare naam. Valt terug
   op '—' als de lookup-map de ID niet kent (bv. medewerker verwijderd
   of nog niet geladen). */
function medewerkerNaamUit(value) {
  const entry = _medewerkerEntryUit(value);
  if (entry && typeof entry === 'object') return entry.naam || '—';
  // Legacy: lookup heeft strings opgeslagen, of waarde is zelf een naam
  if (typeof entry === 'string') return entry;
  if (typeof value === 'string' && value && !value.startsWith('rec')) return value;
  return '—';
}

/* Heeft de medewerker een vast cadeau ingesteld voor dit type moment?
   Wordt gebruikt om "Cadeau gepland via service" te kunnen tonen wanneer
   de auto-cron het moment al heeft aangemaakt maar het cadeau nog niet
   aan dit specifieke moment heeft gehangen (dat gebeurt pas op de 25e). */
function medewerkerHeeftCadeauVoorType(medewerkerValue, type) {
  const entry = _medewerkerEntryUit(medewerkerValue);
  if (!entry || typeof entry !== 'object') return false;
  if (type === 'Verjaardag') return !!entry.cadeauVerjaardag;
  if (type === 'Jubileum' || type === 'Werkjubileum') return !!entry.cadeauJubileum;
  return false;
}

/* Laadt de klant-services-status (verjaardag/jubileum) één keer per
   pagina en cachet op window. Faalt stil als bedrijfsinfo niet
   bereikbaar is — de UI valt dan terug op het oude gedrag. */
async function laadKlantServices() {
  if (window._klantServices && window._klantServices._geladen) return window._klantServices;
  try {
    const rec = await fetchAirtable('Klanten');
    const f = (rec && rec[0] && rec[0].fields) || {};
    window._klantServices = {
      verjaardagActief: f['Verjaardag service actief'] === true,
      jubileumActief:   f['Jubileum service actief']   === true,
      _geladen: true,
    };
  } catch (err) {
    window._klantServices = { verjaardagActief: false, jubileumActief: false, _geladen: true };
  }
  return window._klantServices;
}

/* Filter momenten op de klant-services-status. Verjaardag-momenten
   verdwijnen uit de lijst zodra de verjaardagsservice inactief is —
   want de gebruiker heeft expliciet gezegd "actief is gepland,
   inactief is niet gepland". Hetzelfde geldt voor jubileum-momenten.
   Andere types (Seizoen, Anders) zijn niet aan een service gekoppeld
   en blijven altijd staan. */
function filterMomentenOpService(momenten) {
  const services = (typeof window !== 'undefined' && window._klantServices) || null;
  if (!services || !services._geladen) return momenten;
  return momenten.filter(m => {
    const type = (m.fields && m.fields['Type']) || '';
    if (type === 'Verjaardag') return services.verjaardagActief === true;
    if (type === 'Jubileum' || type === 'Werkjubileum') return services.jubileumActief === true;
    return true;
  });
}

/* Bepaal hoe een cadeau-blok voor een moment getoond moet worden.
   Returns:
     { label: string, viaService: bool } als er iets te tonen is
     null                                  als er echt geen cadeau gepland is
*/
function cadeauStatusVoorMoment(fields) {
  const f = fields || {};
  // 1) Concreet cadeau aan dit moment gekoppeld (linked record naam,
  //    of text-veld 'Cadeau')
  const gekozenProduct = Array.isArray(f['Gekozen Product']) && f['Gekozen Product'][0];
  if (gekozenProduct) return { label: String(gekozenProduct), viaService: false };
  if (f['Cadeau']) return { label: String(f['Cadeau']), viaService: false };

  // 2) Geen concreet cadeau → kijk of de klant-service actief is én
  //    de medewerker een vast cadeau heeft voor dit type.
  const services = (typeof window !== 'undefined' && window._klantServices) || {};
  const type = f['Type'] || '';
  const serviceActief =
    (type === 'Verjaardag'  && services.verjaardagActief) ||
    ((type === 'Jubileum' || type === 'Werkjubileum') && services.jubileumActief);
  if (serviceActief && medewerkerHeeftCadeauVoorType(f['Medewerker'], type)) {
    return {
      label: type === 'Verjaardag'
        ? 'Cadeau gepland via verjaardagsservice'
        : 'Cadeau gepland via jubileumservice',
      viaService: true,
    };
  }
  return null;
}

/* ── Datum naar dit jaar zetten ───────────────────────────────
   Pakt een YYYY-MM-DD datum (geboortedatum of startdatum) en
   verschuift hem naar het komende voorkomen — dus dit jaar als
   die datum nog komt, anders volgend jaar. Zo plant 'Verjaardag'
   altijd in op de eerstvolgende verjaardag. */
function datumNaarVolgendVoorkomen(datumStr) {
  if (!datumStr) return '';
  const parts = datumStr.split('-');
  if (parts.length < 3) return '';
  const maand = parseInt(parts[1], 10) - 1;
  const dag   = parseInt(parts[2], 10);
  const nu = new Date();
  let jaar = nu.getFullYear();
  const kandidaat = new Date(jaar, maand, dag);
  if (kandidaat < new Date(nu.getFullYear(), nu.getMonth(), nu.getDate())) {
    jaar++;
  }
  return `${jaar}-${String(maand + 1).padStart(2, '0')}-${String(dag).padStart(2, '0')}`;
}

/* ── Moment-modal: auto-fill datum bij medewerker + type ──── */
function initMomentModalAutoFill() {
  const medSelect  = document.getElementById('moment-medewerker');
  const typeSelect = document.getElementById('moment-type');
  const datumInput = document.getElementById('moment-datum');
  if (!medSelect || !typeSelect || !datumInput) return;
  if (medSelect.dataset.autofillInit === '1') return;
  medSelect.dataset.autofillInit = '1';

  function vulDatumIn() {
    const opt  = medSelect.options[medSelect.selectedIndex];
    const type = typeSelect.value;
    if (!opt || !type) return;

    let bron = '';
    if (type === 'Verjaardag') bron = opt.dataset.geboortedatum || '';
    else if (type === 'Jubileum') bron = opt.dataset.startdatum || '';

    if (bron) {
      const volgend = datumNaarVolgendVoorkomen(bron);
      if (volgend) datumInput.value = volgend;
    }
  }

  medSelect.addEventListener('change', vulDatumIn);
  typeSelect.addEventListener('change', vulDatumIn);
}

/* ── Bedrijfsinfo laden ───────────────────────────────────── */
// Bedrijfsgegevens zitten in de Klanten-tabel (geen aparte Bedrijfsinformatie-tabel).
// Alleen velden die in Klanten bestaan worden geladen; overige form-velden blijven leeg.
async function laadBedrijfsinfo(klantEmail) {
  if (!klantEmail || !PORTAAL_CONFIG.airtableBaseId) return;

  const records = await fetchAirtable('Klanten', `{Customer Email} = "${klantEmail}"`);
  if (records.length === 0) return;

  const f = records[0].fields || {};

  const recordIdInput = document.getElementById('bedrijf-record-id');
  if (recordIdInput) recordIdInput.value = records[0].id;

  const velden = {
    'bedrijf-naam':            f['Bedrijfsnaam']           || '',
    'bedrijf-startdatum':      f['Startdatum Bedrijf']     || '',
    'bedrijf-kvk':             f['KvK nummer']             || '',
    'bedrijf-btw':             f['BTW nummer']             || '',
    'bedrijf-functie':         f['Functie contactpersoon'] || '',
    'bedrijf-notities':        f['Notities']               || '',
    'bedrijf-telefoon':        f['Customer Phone']         || '',
    'bedrijf-adres':           f['Default Address 1']      || '',
    'bedrijf-postcode':        f['Default Address ZIP']    || '',
    'bedrijf-stad':            f['Default Address City']   || '',
    'bedrijf-contactpersoon': [f['Customer First Name'], f['Customer Last Name']].filter(Boolean).join(' ')
  };

  Object.entries(velden).forEach(([id, val]) => {
    const el = document.getElementById(id);
    if (el) el.value = val;
  });

  const landEl = document.getElementById('bedrijf-land');
  if (landEl && f['Default Address Country']) landEl.value = f['Default Address Country'];
}

/* ── Product Helpers (Feature 10) ─────────────────────────── */
/**
 * Haal de display titel op (custom of origineel)
 */
function getDisplayTitel(productFields) {
  return productFields['Custom Titel'] ||
         productFields['Naam'] ||
         productFields['YS Originele Titel'] ||
         productFields['Product naam'] ||
         'Naamloos product';
}

/**
 * Haal de display beschrijving op (custom of origineel)
 */
function getDisplayBeschrijving(productFields) {
  return productFields['Custom Beschrijving'] ||
         productFields['Beschrijving'] ||
         productFields['YS Originele Beschrijving'] ||
         '';
}

/* ── Cadeau Kiezer (Feature 4) ────────────────────────────── */
/**
 * Open product kiezer modal voor een gepland moment
 */
async function kiesCadeau(momentRecordId) {
  try {
    // Haal actieve producten op
    const producten = await fetchAirtable('Producten', '{Actief} = TRUE()', 'Naam', 'asc');

    if (producten.length === 0) {
      toonToast('Geen actieve producten beschikbaar', 'waarschuwing');
      return;
    }

    const html = `
      <div class="portaal-modal-overlay" id="cadeau-kiezer-modal" onclick="if(event.target === this) removeModal('cadeau-kiezer-modal')">
        <div class="portaal-modal" style="max-width:900px;">
          <div class="portaal-modal__header">
            <h2>Cadeau kiezen</h2>
            <button class="portaal-modal__sluit" onclick="removeModal('cadeau-kiezer-modal')" aria-label="Sluiten">&times;</button>
          </div>
          <div class="portaal-modal__body">
            <div class="portaal-product-grid">
              ${producten.map(p => {
                const f = p.fields || {};
                const naam = getDisplayTitel(f);
                const beschrijving = getDisplayBeschrijving(f);
                const prijs = f['Prijs'] || f['Verkoopprijs'] || 0;
                const afbeelding = f['Afbeelding URL'] || f['Thumbnail'] || '';

                return `
                  <div class="portaal-product-card"
                       onclick="selecteerProduct('${escHtml(momentRecordId)}', '${escHtml(p.id)}', '${escHtml(naam)}')"
                       title="${escHtml(beschrijving).substring(0, 100)}">
                    ${afbeelding ? `<img src="${escHtml(afbeelding)}" alt="${escHtml(naam)}" loading="lazy">` : '<div class="portaal-product-card__no-img">🎁</div>'}
                    <h4>${escHtml(naam)}</h4>
                    <p class="portaal-product-card__prijs">${formatBedrag(prijs)}</p>
                  </div>
                `;
              }).join('')}
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', html);
  } catch (err) {
    console.error('Fout bij laden producten:', err);
    toonToast('Fout bij laden producten', 'fout');
  }
}

/**
 * Selecteer en koppel product aan moment
 */
async function selecteerProduct(momentRecordId, productRecordId, productNaam) {
  try {
    // Toon loading state
    removeModal('cadeau-kiezer-modal');
    toonToast('Cadeau koppelen...', 'info');

    // Update Airtable record met linked product
    await updateAirtableRecord('Geplande Momenten', momentRecordId, {
      'Gekozen Product': [productRecordId]
    });

    toonToast(`Cadeau "${productNaam}" gekoppeld!`, 'sukses');

    // Herlaad de momenten lijst
    const pagina = document.getElementById('portaal-kalender-hoofd') || document.getElementById('portaal-planning-pagina');
    const klantEmail = pagina ? pagina.dataset.klantEmail : '';
    if (klantEmail) {
      await laadMomenten(klantEmail);
    }
  } catch (err) {
    console.error('Fout bij koppelen cadeau:', err);
    toonToast('Fout bij koppelen cadeau', 'fout');
  }
}

/**
 * Verwijder dynamisch aangemaakt modal (bijv. cadeau-kiezer)
 */
function removeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.remove();
  }
}

/* ── Sub-gebruiker functies ───────────────────────────────── */

/**
 * Controleer of het opgegeven e-mailadres een sub-gebruiker is.
 * Geeft het hoofd-email terug als dat zo is, anders null.
 */
async function resolveerEffectiefEmail(eigenEmail) {
  if (!eigenEmail || !PORTAAL_CONFIG.airtableBaseId) {
    return null;
  }

  try {
    const records = await fetchAirtable(
      'Portaal Gebruikers',
      `AND({Sub Email} = "${eigenEmail}", {Status} = "Actief")`
    );

    if (records.length > 0) {
      return records[0].fields['Hoofd Email'] || null;
    }
  } catch (err) {
    // Tabel bestaat nog niet of andere fout — geen probleem
    console.warn('Sub-gebruiker check: tabel Portaal Gebruikers niet gevonden of leeg.');
  }

  return null;
}

/**
 * Toon een informatieve banner als de gebruiker als sub-gebruiker is ingelogd.
 */
function toonSubGebruikerBanner(eigenEmail, hoofdEmail) {
  const main = document.querySelector('.portaal-main');
  if (!main) return;

  const banner = document.createElement('div');
  banner.className = 'portaal-sub-gebruiker-banner';
  banner.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>
    Je bent ingelogd als <strong>medegebruiker</strong>. Je beheert het account van <strong>${escHtml(hoofdEmail)}</strong>.
  `;
  main.insertAdjacentElement('afterbegin', banner);
}

/**
 * Laad de huidige sub-gebruikers van dit hoofd-account.
 * Toont altijd de hoofdgebruiker bovenaan, gevolgd door eventuele sub-gebruikers.
 */
async function laadSubGebruikers(hoofdEmail) {
  const container = document.getElementById('sub-gebruiker-huidig');
  if (!container) return;

  // Haal naam van de ingelogde hoofdgebruiker op uit het data-attribuut
  const pagina = document.getElementById('portaal-bedrijfsinfo-pagina');
  const hoofdNaam = (pagina && pagina.dataset.klantNaam) ? pagina.dataset.klantNaam : hoofdEmail;

  // Toon altijd de hoofdgebruiker bovenaan
  let html = `
    <div style="margin-bottom:12px;">
      <div style="font-size:1.15rem;font-weight:700;color:var(--portaal-navy);margin-bottom:8px;">Huidige gebruikers</div>
      <div class="sub-gebruiker-rij" style="border:1px solid var(--portaal-border);border-radius:10px;padding:14px 18px;background:#fff;display:flex;align-items:center;gap:16px;flex-wrap:wrap;">
        <div style="width:36px;height:36px;border-radius:50%;background:var(--portaal-navy);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:1.3rem;flex-shrink:0;">
          ${escHtml(hoofdNaam.charAt(0).toUpperCase())}
        </div>
        <div style="flex:1;min-width:160px;">
          <div style="font-weight:600;color:#1B2A4A;font-size:1.3rem;">${escHtml(hoofdNaam)}</div>
          <div style="font-size:1.2rem;color:var(--portaal-tekst-muted);">${escHtml(hoofdEmail)}</div>
        </div>
        <span style="display:inline-flex;align-items:center;padding:4px 12px;border-radius:20px;font-size:1.1rem;font-weight:600;background:#EFF6FF;color:#1D4ED8;">Hoofdgebruiker</span>
      </div>
    </div>`;

  container.innerHTML = html;

  if (!PORTAAL_CONFIG.useProxy && !PORTAAL_CONFIG.airtableBaseId) {
    return;
  }

  const recordsRaw = await fetchAirtable(
    'Portaal Gebruikers',
    `AND({Hoofd Email} = "${hoofdEmail}", {Status} != "Verwijderd")`
  );
  // In proxy-mode wordt de filterFormula server-side genegeerd; nogmaals
  // filteren zodat verwijderde sub-gebruikers niet meer getoond worden.
  const records = recordsRaw.filter(r => (r.fields && r.fields['Status']) !== 'Verwijderd');

  const formulier = document.getElementById('sub-gebruiker-uitnodiging-formulier');

  if (records.length === 0) {
    if (formulier) formulier.style.display = '';
    return;
  }

  const record = records[0];
  const f = record.fields || {};
  const status = f['Status'] || 'Uitgenodigd';
  const statusKleur = status === 'Actief' ? '#16a34a' : '#d97706';
  const statusBg   = status === 'Actief' ? '#f0fdf4' : '#fffbeb';

  container.innerHTML += `
    <div class="sub-gebruiker-rij" style="border:1px solid var(--portaal-border);border-radius:10px;padding:14px 18px;background:#fff;display:flex;align-items:center;gap:16px;flex-wrap:wrap;">
      <div style="width:36px;height:36px;border-radius:50%;background:#6B7280;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:1.3rem;flex-shrink:0;">
        ${escHtml((f['Naam'] || f['Sub Email'] || '?').charAt(0).toUpperCase())}
      </div>
      <div style="flex:1;min-width:160px;">
        <div style="font-weight:600;color:#1B2A4A;font-size:1.3rem;">${escHtml(f['Naam'] || '—')}</div>
        <div style="font-size:1.2rem;color:var(--portaal-tekst-muted);">${escHtml(f['Sub Email'] || '—')}</div>
        <div style="font-size:1.15rem;color:#9CA3AF;margin-top:2px;">Uitgenodigd op: ${formatDatum(f['Uitgenodigd Op'])}</div>
      </div>
      <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
        <span style="display:inline-flex;align-items:center;padding:4px 12px;border-radius:20px;font-size:1.1rem;font-weight:600;background:${statusBg};color:${statusKleur};">${escHtml(status)}</span>
        <button class="portaal-knop-danger portaal-knop-sm" onclick="verwijderSubGebruiker('${escHtml(record.id)}', '${escHtml(f['Sub Email'] || '')}')">Verwijderen</button>
      </div>
    </div>`;

  // Verberg uitnodigingsformulier als er al een actieve gebruiker is
  if (formulier) {
    formulier.style.display = status === 'Actief' ? 'none' : '';
    if (status === 'Actief') {
      const bestaandeBericht = formulier.previousElementSibling;
      if (!bestaandeBericht || !bestaandeBericht.classList.contains('sub-gebruiker-max-bericht')) {
        formulier.insertAdjacentHTML('beforebegin', `
          <p class="sub-gebruiker-max-bericht" style="font-size:1.25rem;color:var(--portaal-tekst-muted);margin:8px 0 0;">
            Je hebt al een actieve medegebruiker. Verwijder deze eerst om een nieuwe uit te nodigen.
          </p>`);
      }
    }
  }
}

/**
 * Verstuur een uitnodiging naar een nieuwe sub-gebruiker.
 */
async function nodigSubGebruikerUit(hoofdEmail) {
  if (!hoofdEmail) {
    const pagina = document.getElementById('portaal-bedrijfsinfo-pagina');
    hoofdEmail = pagina ? pagina.dataset.klantEmail : '';
  }

  const naamInput  = document.getElementById('sub-gebruiker-naam');
  const emailInput = document.getElementById('sub-gebruiker-email');
  const knop       = document.getElementById('sub-gebruiker-uitnodigen-knop');

  const naam  = naamInput  ? naamInput.value.trim()  : '';
  const email = emailInput ? emailInput.value.trim() : '';

  if (!naam) {
    toonToast('Vul een naam in voor de medegebruiker', 'fout');
    naamInput && naamInput.focus();
    return;
  }

  if (!email || !email.includes('@')) {
    toonToast('Vul een geldig e-mailadres in', 'fout');
    emailInput && emailInput.focus();
    return;
  }

  if (email.toLowerCase() === hoofdEmail.toLowerCase()) {
    toonToast('Je kunt jezelf niet uitnodigen', 'fout');
    return;
  }

  // Controleer of er al een sub-gebruiker is. In proxy-mode wordt de
  // filterFormula server-side genegeerd, dus filteren we ook nog client-side
  // op Status != "Verwijderd".
  const bestaandRaw = await fetchAirtable(
    'Portaal Gebruikers',
    `AND({Hoofd Email} = "${hoofdEmail}", {Status} != "Verwijderd")`
  );
  const bestaand = bestaandRaw.filter(r => (r.fields && r.fields['Status']) !== 'Verwijderd');

  if (bestaand.length > 0) {
    toonToast('Je hebt al een medegebruiker. Verwijder deze eerst.', 'fout');
    return;
  }

  if (knop) { knop.textContent = 'Versturen…'; knop.disabled = true; }

  try {
    if (PORTAAL_CONFIG.useProxy) {
      // Veilige route: één call naar /sub-gebruikers/uitnodigen — de server
      // maakt het Airtable-record aan EN triggert de Make-webhook voor mail.
      await postWebhook(PORTAAL_CONFIG.makeWebhooks.gebruikerUitnodigen, {
        hoofd_email: hoofdEmail,
        sub_email:   email.toLowerCase(),
        sub_naam:    naam,
        // Server verwacht 'Sub Email' en 'Naam' als top-level fields (zie
        // ALLOWED_FIELDS_IN in sub-gebruikers.js); we sturen beide formats.
        'Sub Email': email.toLowerCase(),
        'Naam':      naam,
        portaal_url: window.location.origin + '/pages/portaal'
      });
    } else {
      // Legacy mode: rechtstreeks Airtable + losse Make-webhook.
      await createAirtableRecord('Portaal Gebruikers', {
        'Hoofd Email':    hoofdEmail,
        'Sub Email':      email.toLowerCase(),
        'Naam':           naam,
        'Status':         'Uitgenodigd',
        'Uitgenodigd Op': new Date().toISOString().split('T')[0]
      });

      if (PORTAAL_CONFIG.makeWebhooks.gebruikerUitnodigen) {
        try {
          await postWebhook(PORTAAL_CONFIG.makeWebhooks.gebruikerUitnodigen, {
            hoofd_email: hoofdEmail,
            sub_email:   email,
            sub_naam:    naam,
            portaal_url: window.location.origin + '/pages/portaal'
          });
        } catch (webhookErr) {
          console.warn('Uitnodigings-webhook niet geconfigureerd of mislukt:', webhookErr);
        }
      }
    }

    toonToast(`Uitnodiging verstuurd naar ${email}`, 'sukses');

    if (naamInput)  naamInput.value  = '';
    if (emailInput) emailInput.value = '';

    await laadSubGebruikers(hoofdEmail);
  } catch (err) {
    console.error('Fout bij uitnodigen sub-gebruiker:', err);
    toonToast('Fout bij versturen uitnodiging. Probeer opnieuw.', 'fout');
  } finally {
    if (knop) { knop.textContent = 'Uitnodiging versturen'; knop.disabled = false; }
  }
}

/**
 * Verwijder een sub-gebruiker (status op 'Verwijderd' zetten).
 */
async function verwijderSubGebruiker(recordId, subEmail) {
  const ok = await bevestig({
    titel: 'Medegebruiker verwijderen?',
    tekst: `${subEmail} verliest direct toegang tot het portaal. Je kunt later een nieuwe medegebruiker uitnodigen.`,
    bevestigTekst: 'Ja, verwijderen',
    destructief: true
  });
  if (!ok) return;

  try {
    if (PORTAAL_CONFIG.useProxy) {
      // Server doet zelf de soft-delete (Status='Verwijderd') op de DELETE-call.
      // deleteAirtableRecord retourneert false bij fout in plaats van te throwen,
      // dus we checken expliciet.
      const ok = await deleteAirtableRecord('Portaal Gebruikers', recordId);
      if (!ok) throw new Error('Verwijderen geweigerd door server');
    } else {
      await updateAirtableRecord('Portaal Gebruikers', recordId, { 'Status': 'Verwijderd' });
    }
    toonToast('Medegebruiker verwijderd', 'sukses');

    // Verberg de rij direct uit de UI (optimistisch), zonder te wachten op Airtable
    const container = document.getElementById('sub-gebruiker-huidig');
    if (container) {
      const rijen = container.querySelectorAll('.sub-gebruiker-rij');
      // Verberg de laatste rij (de sub-gebruiker — de eerste is altijd de hoofdgebruiker)
      if (rijen.length > 1) rijen[rijen.length - 1].closest('div').style.display = 'none';
    }
    // Toon uitnodigingsformulier weer
    const formulier = document.getElementById('sub-gebruiker-uitnodiging-formulier');
    if (formulier) formulier.style.display = '';
    // Verwijder max-bericht als dat er staat
    const maxBericht = document.querySelector('.sub-gebruiker-max-bericht');
    if (maxBericht) maxBericht.remove();

    // Herlaad na 1,5 seconde zodat Airtable bijgewerkt is
    const pagina = document.getElementById('portaal-bedrijfsinfo-pagina');
    const hoofdEmail = pagina ? pagina.dataset.klantEmail : '';
    if (hoofdEmail) setTimeout(() => laadSubGebruikers(hoofdEmail), 1500);
  } catch (err) {
    toonToast('Fout bij verwijderen. Probeer opnieuw.', 'fout');
  }
}

/* ── CRM Koppeling ────────────────────────────────────────── */

/**
 * Laad de huidige CRM koppeling status voor dit bedrijf.
 * In proxy-mode komt de info via /api/bedrijfsinfo (de server geeft alleen
 * "is gekoppeld + masker" terug, NIET de echte key). In legacy-mode lezen
 * we direct uit Airtable.
 */
async function laadCrmStatus(klantEmail) {
  const statusContainer = document.getElementById('crm-status-container');
  if (!statusContainer) return;

  if (!PORTAAL_CONFIG.useProxy && !PORTAAL_CONFIG.airtableBaseId) return;

  const records = await fetchAirtable('Klanten', `{Customer Email} = "${klantEmail}"`);
  if (records.length === 0) return;

  const f = records[0].fields || {};
  window._klantRecordId = records[0].id;

  // In proxy-mode komt de CRM-info als geprojecteerd object terug, niet als
  // losse velden. (De server stript expliciet de versleutelde key.)
  const crmObj  = f.crm || null;
  const crmSysteem      = (crmObj && crmObj.systeem) || f['CRM Systeem'] || '';
  const crmAangesloten  = (crmObj && crmObj.connectedAt) || f['CRM Aangesloten Op'] || '';
  const crmLaatsteSync  = (crmObj && crmObj.lastSync)  || f['CRM Laatste Sync'] || '';
  const heeftKey        = !!(crmObj && crmObj.apiKeyMask) || !!f['CRM API Key'];

  // Pre-fill formulier velden
  const systeemSelect = document.getElementById('crm-systeem-select');
  const apiKeyInput   = document.getElementById('crm-api-key-input');
  const apiUrlInput   = document.getElementById('crm-api-url-input');

  if (systeemSelect && crmSysteem) {
    systeemSelect.value = crmSysteem;
    toggleApiUrlVeld(crmSysteem);
  }

  if (apiKeyInput && heeftKey) {
    apiKeyInput.value = '••••••••••••••••';
    apiKeyInput.dataset.heeftBestaandeKey = '1';
  }

  if (apiUrlInput && f['CRM API URL']) {
    apiUrlInput.value = f['CRM API URL'];
  }

  // Status badge tonen
  if (crmSysteem) {
    statusContainer.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 18px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;flex-wrap:wrap;">
        <div style="display:flex;align-items:center;gap:10px;">
          <span style="font-size:1.3rem;color:#16a34a;">✓</span>
          <div>
            <div style="font-weight:600;color:#15803d;">Gekoppeld: ${escHtml(crmSysteem)}</div>
            ${crmAangesloten ? `<div style="font-size:0.8rem;color:#666;margin-top:2px;">Gekoppeld op: ${formatDatum(crmAangesloten)}</div>` : ''}
            ${crmLaatsteSync
              ? `<div style="font-size:0.8rem;color:#666;">Laatste sync: ${formatDatum(crmLaatsteSync)}</div>`
              : `<div style="font-size:0.8rem;color:#999;">Nog niet gesynchroniseerd</div>`}
          </div>
        </div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;">
          <button class="portaal-knop-secondary portaal-knop-sm"
                  onclick="testCrmVerbinding('${escHtml(klantEmail)}')">
            Verbinding testen
          </button>
          <button class="portaal-knop-danger portaal-knop-sm"
                  onclick="verwijderCrmKoppeling('${escHtml(klantEmail)}')">
            Koppeling verwijderen
          </button>
        </div>
      </div>`;
  } else {
    // Geen CRM gekoppeld: geen banner tonen. Het koppelingsformulier
    // daaronder spreekt voor zichzelf — een aparte "Nog geen CRM"-melding
    // is daarbovenop dubbelop.
    statusContainer.innerHTML = '';
  }
}

/**
 * Toon of verberg de juiste invoer-velden per CRM en pas labels/helptekst aan.
 * Per CRM betekent het "API URL"-veld iets anders:
 *   AFAS      → omgevings-URL
 *   HubSpot   → List-ID (van de Medewerkers-list)
 *   Pipedrive → Filter-ID (van de Persons-filter)
 *   Salesforce→ SOQL WHERE-fragment (extra rij voor Consumer Secret zichtbaar)
 *   Exact     → niets (OAuth-flow via knop)
 */
function toggleApiUrlVeld(systeem) {
  const urlRij       = document.getElementById('crm-api-url-rij');
  const secretRij    = document.getElementById('crm-consumer-secret-rij');
  const myDomainRij  = document.getElementById('crm-my-domain-rij');
  const keyRij       = document.getElementById('crm-api-key-input')?.closest('.portaal-form-groep');
  const keyLabelEl   = document.getElementById('crm-api-key-label-text');
  const urlLabelEl   = document.getElementById('crm-api-url-label-text');
  const helpEl       = document.getElementById('crm-api-url-helptekst');
  const keyInput     = document.getElementById('crm-api-key-input');
  const urlInput     = document.getElementById('crm-api-url-input');

  // Defaults
  let toonUrl = false;
  let toonSecret = false;
  let toonMyDomain = false;
  let toonKey = true;
  let keyLabel = 'API key / token';
  let keyPlaceholder = 'Plak hier je API key of token';
  let urlLabel = 'API URL';
  let urlPlaceholder = 'https://jouwbedrijf.crm.nl/api';
  let helpTekst = '';

  switch (systeem) {
    case 'AFAS':
      toonUrl = true;
      urlLabel = 'API URL';
      urlPlaceholder = 'https://12345.afas.online/profitrestservices';
      helpTekst = 'Vervang 12345 door jouw omgevingsnummer.';
      break;
    case 'HubSpot':
      toonUrl = true;
      urlLabel = 'List-ID';
      urlPlaceholder = 'bijv. 67';
      helpTekst = 'Het List-ID van je "Medewerkers"-list (HubSpot → Lijsten → je lijst → Details). Vul alléén het getal in.';
      break;
    case 'Pipedrive':
      toonUrl = true;
      urlLabel = 'Filter-ID';
      urlPlaceholder = 'bijv. 42';
      helpTekst = 'Het ID-nummer van je "Medewerkers"-filter in Pipedrive (uit de URL).';
      break;
    case 'Salesforce':
      toonUrl = true;
      toonSecret = true;
      toonMyDomain = true;
      keyLabel = 'Consumer Key';
      keyPlaceholder = 'Plak hier je Consumer Key';
      urlLabel = 'Filter (WHERE-clause)';
      urlPlaceholder = "AccountId = '0017Q00000abc'";
      helpTekst = 'Een SOQL WHERE-fragment dat aangeeft welke Contacts medewerkers zijn.';
      break;
    case 'Exact Online':
      // Exact gebruikt OAuth-knop in de instructie-blok; geen velden nodig.
      toonKey = false;
      toonUrl = false;
      break;
    default:
      break;
  }

  if (keyRij) keyRij.style.display = toonKey ? '' : 'none';
  if (urlRij) urlRij.style.display = toonUrl ? '' : 'none';
  if (secretRij) secretRij.style.display = toonSecret ? '' : 'none';
  if (myDomainRij) myDomainRij.style.display = toonMyDomain ? '' : 'none';
  if (keyLabelEl) keyLabelEl.textContent = keyLabel;
  if (keyInput) keyInput.placeholder = keyPlaceholder;
  if (urlLabelEl) urlLabelEl.textContent = urlLabel;
  if (urlInput) urlInput.placeholder = urlPlaceholder;
  if (helpEl) helpEl.textContent = helpTekst;

  // Koppel-knop verbergen voor Exact (de OAuth-knop zit in de instructie)
  const koppelKnop = document.getElementById('crm-koppelen-knop');
  if (koppelKnop) koppelKnop.style.display = (systeem === 'Exact Online') ? 'none' : '';

  // Verberg alle instructieblokken
  document.querySelectorAll('.crm-instructie-blok').forEach(el => {
    el.style.display = 'none';
    const details = el.querySelector('details');
    if (details) details.open = false;
  });

  // Toon de instructie voor het gekozen systeem (automatisch open)
  const instructieMap = {
    'HubSpot':      'crm-instructie-hubspot',
    'Pipedrive':    'crm-instructie-pipedrive',
    'Salesforce':   'crm-instructie-salesforce',
    'Exact Online': 'crm-instructie-exact',
    'AFAS':         'crm-instructie-afas'
  };

  if (systeem && instructieMap[systeem]) {
    const blok = document.getElementById(instructieMap[systeem]);
    if (blok) {
      blok.style.display = '';
      const details = blok.querySelector('details');
      if (details) details.open = true;
    }
  }
}

/**
 * Start de Exact OAuth-flow: vraag een autorisatie-URL aan de server,
 * redirect de browser daarnaartoe. Exact stuurt de klant daarna terug
 * naar /oauth/exact/callback op de portal-server, die op zijn beurt
 * doorstuurt naar deze pagina met #crm-oauth-ok:exact in de URL.
 */
async function startExactOauth() {
  const knop = document.getElementById('exact-verbinden-knop');
  if (!PORTAAL_CONFIG.useProxy) {
    toonToast('Exact-koppeling vereist het beveiligde portaal.', 'fout');
    return;
  }
  if (knop) { knop.textContent = 'Bezig…'; knop.disabled = true; }
  try {
    const apiBase = PORTAAL_CONFIG.apiBase || '/apps/portaal-api';
    const res = await fetch(apiBase.replace(/\/$/, '') + '/crm/exact/start', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.authUrl) throw new Error(data.error || 'Kon autorisatie-link niet ophalen');
    window.location.href = data.authUrl;
  } catch (err) {
    toonToast(err.message || 'Exact-koppeling kon niet starten', 'fout');
    if (knop) { knop.textContent = 'Verbind met Exact Online'; knop.disabled = false; }
  }
}

/**
 * Sla de CRM koppeling op. In proxy-mode gaat de plain-text key naar
 * /api/bedrijfsinfo/crm/koppelen, waar hij server-side AES-256-GCM versleuteld
 * in Airtable wordt opgeslagen (veld "CRM API Key Encrypted"). De key verlaat
 * de server NOOIT in leesbare vorm — niet in logs, niet in browser-source.
 */
async function slaanCrmKoppeling(klantEmail) {
  const systeemSelect = document.getElementById('crm-systeem-select');
  const apiKeyInput   = document.getElementById('crm-api-key-input');
  const apiUrlInput   = document.getElementById('crm-api-url-input');
  const secretInput   = document.getElementById('crm-consumer-secret-input');
  const myDomainInput = document.getElementById('crm-my-domain-input');
  const knop          = document.getElementById('crm-koppelen-knop');

  const systeem = systeemSelect ? systeemSelect.value : '';
  const apiKey  = apiKeyInput   ? apiKeyInput.value.trim()  : '';
  const apiUrl  = apiUrlInput   ? apiUrlInput.value.trim()  : '';
  const consumerSecret = secretInput ? secretInput.value.trim() : '';
  const myDomain = myDomainInput ? myDomainInput.value.trim() : '';

  if (!systeem) {
    toonToast('Kies eerst een CRM-systeem', 'fout');
    return;
  }
  if (systeem === 'Exact Online') {
    toonToast('Gebruik de "Verbind met Exact"-knop hierboven', 'fout');
    return;
  }

  const heeftBestaandeKey = apiKeyInput && apiKeyInput.dataset.heeftBestaandeKey === '1';
  const apiKeyGewijzigd   = apiKey && apiKey !== '••••••••••••••••';

  if (!heeftBestaandeKey && !apiKeyGewijzigd) {
    toonToast('Vul je API key in', 'fout');
    return;
  }
  if (systeem === 'Salesforce' && apiKeyGewijzigd && !consumerSecret) {
    toonToast('Vul ook je Consumer Secret in', 'fout');
    return;
  }
  if (systeem === 'Salesforce' && apiKeyGewijzigd && !myDomain) {
    toonToast('Vul je Salesforce My Domain in (bijv. mijnbedrijf.my.salesforce.com)', 'fout');
    return;
  }

  if (knop) { knop.textContent = 'Koppelen…'; knop.disabled = true; }

  try {
    if (PORTAAL_CONFIG.useProxy) {
      // Veilige route: server versleutelt en slaat op
      const apiBase = PORTAAL_CONFIG.apiBase || '/apps/portaal-api';
      const payload = {
        systeem,
        apiKey: apiKeyGewijzigd ? apiKey : '__keep__',
        apiUrl: apiUrl || '',
      };
      if (systeem === 'Salesforce' && consumerSecret) {
        payload.consumerSecret = consumerSecret;
      }
      if (systeem === 'Salesforce' && myDomain) {
        payload.myDomain = myDomain;
      }
      const res = await fetch(apiBase.replace(/\/$/, '') + '/bedrijfsinfo/crm/koppelen', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
    } else {
      // Legacy fallback (alleen voor migratie — onveilig)
      const records  = await fetchAirtable('Klanten', `{Customer Email} = "${klantEmail}"`);
      const recordId = records.length > 0 ? records[0].id : (window._klantRecordId || null);
      if (!recordId) {
        toonToast('Klantrecord niet gevonden. Neem contact op met Secret Gifters.', 'fout');
        return;
      }
      const velden = {
        'CRM Systeem':        systeem,
        'CRM Aangesloten Op': new Date().toISOString().split('T')[0]
      };
      if (apiKeyGewijzigd) velden['CRM API Key'] = apiKey;
      if (apiUrl)          velden['CRM API URL'] = apiUrl;
      await updateAirtableRecord('Klanten', recordId, velden);
    }

    toonToast(`✓ ${systeem} succesvol gekoppeld`, 'sukses');

    // Placeholder herstellen zodat de echte key verborgen blijft
    if (apiKeyInput) {
      apiKeyInput.value = '••••••••••••••••';
      apiKeyInput.dataset.heeftBestaandeKey = '1';
    }

    await laadCrmStatus(klantEmail);
  } catch (err) {
    console.error('CRM koppelen fout:', err);
    toonToast(err.message || 'Fout bij koppelen. Probeer opnieuw.', 'fout');
  } finally {
    if (knop) { knop.textContent = 'Koppelen'; knop.disabled = false; }
  }
}

/**
 * Trigger een handmatige synchronisatie via de portal-server.
 * De server haalt zelf medewerkers op uit het CRM (AFAS/Exact) en schrijft
 * ze direct naar Airtable. Geen Make-webhook tussenstap meer; de
 * versleutelde key blijft in server-memory.
 */
async function triggerCrmSync(klantEmail) {
  const knop = document.getElementById('crm-sync-knop');

  if (!PORTAAL_CONFIG.useProxy) {
    toonToast('CRM-synchronisatie vereist het beveiligde portaal. Neem contact op met Secret Gifters.', 'fout');
    return;
  }

  if (knop) { knop.textContent = 'Synchroniseren…'; knop.disabled = true; }

  try {
    const apiBase = PORTAAL_CONFIG.apiBase || '/apps/portaal-api';
    const res = await fetch(apiBase.replace(/\/$/, '') + '/crm/sync', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);

    const { aangemaakt = 0, overgeslagen = 0, opgehaald = 0, fouten = [], verdwenen = 0, truncated = false } = data;
    let bericht = `✓ ${aangemaakt} nieuw • ${overgeslagen} bestaand`;
    if (fouten.length) bericht += ` • ${fouten.length} fout`;
    toonToast(bericht, aangemaakt > 0 || overgeslagen > 0 ? 'sukses' : 'fout');

    // Niet alle medewerkers opgehaald (lijst groter dan de pagineer-limiet).
    if (truncated) {
      toonToast('Let op: niet alle medewerkers konden worden opgehaald (lijst erg groot). Neem contact op met Secret Gifters.', 'waarschuwing');
    }
    // Medewerkers die wél in het portaal staan maar niet meer in het CRM.
    // Informatief: we verwijderen ze niet automatisch.
    if (verdwenen > 0) {
      toonToast(`${verdwenen} medewerker(s) in het portaal staan niet meer in je CRM. Controleer of je ze handmatig wilt verwijderen.`, 'waarschuwing');
    }

    // Even wachten zodat Airtable klaar is met schrijven, dan herladen
    if (typeof laadMedewerkers === 'function') {
      setTimeout(() => laadMedewerkers(klantEmail, 'medewerkers-tabel-container'), 1000);
    }
    await laadCrmStatus(klantEmail);
  } catch (err) {
    console.error('CRM sync fout:', err);
    toonToast(err.message || 'Synchronisatie mislukt. Probeer opnieuw of neem contact op.', 'fout');
  } finally {
    if (knop) { knop.textContent = 'Nu synchroniseren'; knop.disabled = false; }
  }
}

/**
 * Test de opgeslagen CRM-credentials zonder een volledige sync.
 * Roept /api/crm/verify aan; geeft direct feedback of de koppeling werkt.
 * (Bij Exact wordt en passant de geroteerde refresh-token server-side bewaard.)
 */
async function testCrmVerbinding(klantEmail) {
  if (!PORTAAL_CONFIG.useProxy) {
    toonToast('Verbinding testen vereist het beveiligde portaal. Neem contact op met Secret Gifters.', 'fout');
    return;
  }
  toonToast('Verbinding testen…', '');
  try {
    const apiBase = PORTAAL_CONFIG.apiBase || '/apps/portaal-api';
    const res = await fetch(apiBase.replace(/\/$/, '') + '/crm/verify', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    });
    const data = await res.json().catch(() => ({}));
    if (res.ok && data.ok) {
      toonToast('✓ Verbinding werkt', 'sukses');
    } else {
      toonToast(`Verbinding mislukt: ${data.reason || data.error || 'controleer je gegevens'}`, 'fout');
    }
  } catch (err) {
    toonToast(err.message || 'Testen mislukt. Probeer opnieuw.', 'fout');
  }
}

/**
 * Toon/verberg het "systeem aanvragen"-formulier onder de knop.
 */
function toggleCrmAanvraag() {
  const p = document.getElementById('crm-aanvraag-popup');
  if (!p) return;
  const open = p.style.display !== 'none' && p.style.display !== '';
  p.style.display = open ? 'none' : 'block';
  if (!open) {
    const i = document.getElementById('crm-aanvraag-systeem');
    if (i) i.focus();
  }
}

/**
 * Vraag een CRM/HR-systeem aan dat nog niet in de lijst staat.
 * Stuurt het verzoek server-side door als mail naar Nicole (info@secretgifters.nl).
 */
async function vraagSysteemAan() {
  if (!PORTAAL_CONFIG.useProxy) {
    toonToast('Aanvragen kan via het beveiligde portaal. Mail anders naar info@secretgifters.nl.', 'fout');
    return;
  }
  const sysEl = document.getElementById('crm-aanvraag-systeem');
  const opmEl = document.getElementById('crm-aanvraag-opmerking');
  const systeem = sysEl ? sysEl.value.trim() : '';
  const opmerking = opmEl ? opmEl.value.trim() : '';
  if (!systeem) {
    toonToast('Vul in welk systeem je wilt koppelen', 'fout');
    return;
  }
  const knop = document.getElementById('crm-aanvraag-verstuur');
  if (knop) { knop.textContent = 'Versturen…'; knop.disabled = true; }
  try {
    const apiBase = (PORTAAL_CONFIG.apiBase || '/apps/portaal-api').replace(/\/$/, '');
    const res = await fetch(apiBase + '/crm/aanvraag', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ systeem: systeem, opmerking: opmerking })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) throw new Error(data.error || ('HTTP ' + res.status));
    toonToast('✓ Aanvraag verstuurd. We nemen contact met je op.', 'sukses');
    if (sysEl) sysEl.value = '';
    if (opmEl) opmEl.value = '';
    const p = document.getElementById('crm-aanvraag-popup');
    if (p) p.style.display = 'none';
  } catch (err) {
    toonToast(err.message || 'Versturen mislukt. Probeer opnieuw of mail info@secretgifters.nl.', 'fout');
  } finally {
    if (knop) { knop.textContent = 'Versturen naar Secret Gifters'; knop.disabled = false; }
  }
}

/**
 * Verwijder de CRM koppeling uit Airtable.
 */
async function verwijderCrmKoppeling(klantEmail) {
  const ok = await bevestig({
    titel: 'CRM-koppeling verwijderen?',
    tekst: 'De API-key wordt verwijderd en automatische synchronisatie stopt. Je kunt opnieuw koppelen wanneer je wilt.',
    bevestigTekst: 'Ja, verwijderen',
    destructief: true
  });
  if (!ok) return;

  try {
    if (PORTAAL_CONFIG.useProxy) {
      const apiBase = PORTAAL_CONFIG.apiBase || '/apps/portaal-api';
      const res = await fetch(apiBase.replace(/\/$/, '') + '/bedrijfsinfo/crm/ontkoppelen', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
    } else {
      const records = await fetchAirtable('Klanten', `{Customer Email} = "${klantEmail}"`);
      if (records.length === 0) return;
      await updateAirtableRecord('Klanten', records[0].id, {
        'CRM Systeem':        null,
        'CRM API Key':        null,
        'CRM API URL':        null,
        'CRM Aangesloten Op': null
      });
    }

    toonToast('CRM koppeling verwijderd', 'sukses');

    // Formulier leegmaken
    const systeemSelect = document.getElementById('crm-systeem-select');
    const apiKeyInput   = document.getElementById('crm-api-key-input');
    const apiUrlInput   = document.getElementById('crm-api-url-input');
    const secretInput   = document.getElementById('crm-consumer-secret-input');
    const myDomainInput = document.getElementById('crm-my-domain-input');

    if (systeemSelect) systeemSelect.value = '';
    if (apiKeyInput)   { apiKeyInput.value = ''; delete apiKeyInput.dataset.heeftBestaandeKey; }
    if (apiUrlInput)   apiUrlInput.value = '';
    if (secretInput)   secretInput.value = '';
    if (myDomainInput) myDomainInput.value = '';

    toggleApiUrlVeld('');
    await laadCrmStatus(klantEmail);
  } catch (err) {
    toonToast('Fout bij verwijderen koppeling. Probeer opnieuw.', 'fout');
  }
}

/* ── Initialiseer bij DOM ready ───────────────────────────── */
document.addEventListener('DOMContentLoaded', initPortaal);
